import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {  Formik, Form, Field } from 'formik';
import { LinearProgress, Fab, Tooltip, Box, Modal, Fade, TextField, Backdrop, Typography, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, 
  Stepper, Step, StepLabel, List, ListItem, ListItemText, Divider, MenuItem} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Support from '../../components/support/Support';
import Skeleton from "@mui/material/Skeleton"
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssistantIcon from '@mui/icons-material/Assistant';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import MultilineChartIcon from '@mui/icons-material/MultilineChart';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SettingsApplicationIcon from '@mui/icons-material/SettingsApplications';
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
import Video from '../../components/VideoPlayer/Video'
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import { useTheme } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import { mongoUrl } from '../../components/shared/mongoUrl.js';
import { baseUrl } from '../../components/shared/baseUrl';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators.js";
import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "../../components/assets/jss/material-dashboard-react.js";





const styles = (theme) =>({
   cardTitle: {
        color: 'blue',
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
          color: grayColor[1],
          fontWeight: "400",
          lineHeight: "1"
        }
      },
     cardCategory: {
        color: grayColor[0],
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
      },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily:"'Oswald'",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
  },
  styleChatbutton: {
    color: "black",
    padding: "16px 20px",
    border: "none",
    cursor: "pointer",
    opacity: "0.8",
    position: "fixed",
    zIndex: "10 !important",
    bottom: "23px",
    right: "28px",
    fontWeight: "300",
  },
  chatClose: {
    position: "fixed",
    zIndex: "10 !important",
    bottom: "485px",
    right: "20px",
  },
  chatContainer: {
    zIndex: "10 !important",
    position: "fixed",
    bottom: "110px",
    right: "22px",
  },
  fontCursive: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  fontGaramond: {
    fontFamily:"'Garamond', 'Serif'"
  },
  fontPapyrus:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  fontBrush: {
    fontFamily:"'Brush Script MT', 'Cursive'"
  },
  fontMonaco:{
    fontFamily:"'Monaco','monospace'"
  },
  fontCourier:{
    fontFamily:"'Courier New', 'monospace'"
  },
  fontLucida:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  deco:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  abs:{
    fontFamily:"'Monaco','monospace'"
  },
  algo: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  pat:{
    fontFamily:"'Courier New', 'monospace'"
  },
  ana:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontFamily:"'Lucida Handwriting', 'Brush Script MT'"

  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    fontFamily:"'Lucida Console', 'monospace'"

  },
  modal: {
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
  },
  modal1:{
    position: 'relative',
    maxWidth: '1000px',
    margin : '0 auto',
    padding: '20px 20px 20px 20px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  modal2:{
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '40vh',
    overflowY: 'auto'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
  }
});

var numberList = [
  { label: 'none', value: ''},{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
  , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
  , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
  , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
  , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
  , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
  , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
  , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
  , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 54}, { label: 75, value: 75}
  , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
  , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
  , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
];

var numberNewList = [
  { label: 'none', value: ''},{ label: 'n', value: 'n' },{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
  , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
  , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
  , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
  , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
  , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
  , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
  , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
  , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 54}, { label: 75, value: 75}
  , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
  , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
  , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
];


var cla = {
  "_id":"6006f33eef2c0d65ccbf6601",
  "title": "Class IX",
  "teacherId":"5fe192d970d8c633c005da24"
}

var bracketList = [
  { label: '(', value: '(' },
  { label: ')', value: ')'}
];

var pairList = [
  { label: 'Pairwise sum=', value: 'Pairwise sum=' },
  { label: 'Pair count=', value: 'Pair count='}
];
var nVarList = [
  {label: 'n', value: 'n'},
  {label: '', value: ''}
]

var textAlgoList = [
  {label: 'input', value: 'input'},
  {label: 'output', value: 'output'},
  {label: 'define', value: 'define'},
  {label: 'set', value: 'set'},
  {label: 'to', value: 'to'},
  {label: 'output', value: 'output'}
]

var compareList = [
  { label: '=', value: '=' },
  { label: '==', value: '==' },
  { label: '!=', value: '!=' },
  { label: '>', value: '>' },
  { label: '>=', value: '>=' },
  { label: '<', value: '<' },
  { label: '<=', value: '<=' }
]

var operatorList = [
  { label: '+', value: '+' },
  { label: '-', value: '-'},
  { label: '*', value: '*'},
  { label: '/', value: '/'},
  { label: 'none', value: ''}
];

var termList = [
  { label: '... upto 40 terms', value: '... upto 40 terms' },
  { label: '... upto 20 terms', value: '... upto 20 terms'},
  { label: 'none', value: ''}
];

var alternateList = [
  { label: 'Individual addition', value: 'Individual addition' },
  { label: 'Pairwise addition', value: 'Pairwise addition'}
];

var task = ['Find a way to calculate sum of 40 odd numbers from 1 to 79', 'Find a formula to calculate sum of 40 odd numbers from 1 to 79',
 'How to write the total sum in terms of n=40', 'Write an algorithm to find the sum of first n odd numbers',
'Analyse the algorithm to count maximum number of operations(+,-,*,/,increment,decrement) used in algorithm and total extra variables defined in the algorithm', 'Write an algorithm to find the sum of first n odd numbers', 'Compare the solutions (click to select a solution)']


function getSteps() {
  return ['Decomposition', 'Pattern Recognition', 'Abstraction', 'Algorithm design', 'Analysis of Algorithm', 'Solution', 'Comparison'];
}

const hintsActivity1 = [
  { step: 'Decomposition'},
  { step: 'Pattern recognition'},
  { step: 'Abstraction' },
  { step: 'Algorithm design'},
  { step: 'Analysis of Algorithm' },
  { step: 'Final solution'},
  { step: 'Comparison'}
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};




export default function Hypothesis(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [myCount, setmyCount] = React.useState(10);
    const [isSubmit, setisSubmit] = React.useState(false);
    const [myDecoCount, setmyDecoCount] = React.useState(10);
    const [finalCount, setfinalCount] = React.useState(19);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes =styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false); 
    const [addition, setaddition] = React.useState('Individual addition');
    const [term, setterm] = React.useState('... upto 40 terms');  
    const [num1, setnum1] = React.useState('1');
    const [num2, setnum2] = React.useState('1');
    const [num3, setnum3] = React.useState('1');
    const [num4, setnum4] = React.useState('1');
    const [num5, setnum5] = React.useState('1');
    const [num6, setnum6] = React.useState('1');
    const [mydata, setmydata] = React.useState('');
    const [mydeco, setmydeco] = React.useState('');
    const [mydeco1, setmydeco1] = React.useState('');
    const [mydeco2, setmydeco2] = React.useState('');
    const [mydeco3, setmydeco3] = React.useState('');
    const [patnum1, setpatnum1] = React.useState('');
    const [patnum2, setpatnum2] = React.useState('');
    const [patnum3, setpatnum3] = React.useState('');
    const [patnum4, setpatnum4] = React.useState('');
    const [patnum5, setpatnum5] = React.useState('');
    const [patnum6, setpatnum6] = React.useState('');
    const [patnum7, setpatnum7] = React.useState('');
    const [patnum8, setpatnum8] = React.useState('');
    const [mypattern, setmypattern] = React.useState('');
    const [mypattern1, setmypattern1] = React.useState('');
    const [mypattern2, setmypattern2] = React.useState('');
    const [myabstract, setmyabstract] = React.useState('');
    const [abs1, setabs1] = React.useState('');
    const [abs2, setabs2] = React.useState('');
    const [abs3, setabs3] = React.useState('');
    const [abs4, setabs4] = React.useState('');
    const [abs5, setabs5] = React.useState('');
    const [abs6, setabs6] = React.useState('');
    const [abs7, setabs7] = React.useState('');
    const [absNum, setabsNum] = React.useState('40');
    const [algo1, setalgo1] = React.useState('');
    const [algo2, setalgo2] = React.useState('');
    const [algo3, setalgo3] = React.useState('');
    const [algo4, setalgo4] = React.useState('');
    const [myalgo, setmyalgo] = React.useState('n');
    const [myalgo1, setmyalgo1] = React.useState('');
    const [myalgo2, setmyalgo2] = React.useState('');
    const [myalgo3, setmyalgo3] = React.useState('');
    const [myalgo4, setmyalgo4] = React.useState('');
    const [myalgo5, setmyalgo5] = React.useState('');
    const [myanalysis, setmyanalysis] = React.useState('');
    const [mytime, setmytime] = React.useState('');
    const [myspace, setmyspace] = React.useState('');
    const [mycomsol, setmycomsol] = React.useState('');
    const [mycomsol1, setmycomsol1] = React.useState('');
    const [mycomsol2, setmycomsol2] = React.useState('');
    const [mycomsol3, setmycomsol3] = React.useState('');
    const [sollist, setsollist] = React.useState([]);
    const [wait, setwait] = React.useState(false);
    const [openBoard, setopenBoard] = React.useState(false);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(true);
    const [myModalTwo, setmyModalTwo] = React.useState(true);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [altHint, setaltHint] = React.useState('');
    const [mysum, setmysum] = React.useState('0');
    const [totaldata, settotaldata] = React.useState('')
    //const classes = styles1(theme)
    const [arrStore, setarrStore]= React.useState([])
    const { classId, sesId } = useParams();





    

    useEffect(() => {



        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        console.log(classId)
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          
          setclas(cla)

            
          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((resp) =>{
            if(resp.data.activity2[0].problemStatement!==''){
              const activity = resp.data.activity2[0]

              console.log('already started activity')
                setmydata(activity)
                settotaldata(resp.data)
                if(activity.decomposition.length=='0'){
                  setmydeco('')
                  setmydeco1('')
                  setmydeco2('')
                }
                else{
                  var arr = activity.decomposition[0].userText.split('+')
                  //console.log(arr.length)
                  if(arr.length==7){
                    
                    var n = arr[0].split(':')
                    setnum1(n[1])
                    setnum2(arr[1])
                    setnum3(arr[2])
                    setnum4(arr[3])
                    setnum5(arr[4])
                    setnum6(arr[5])
                    setaddition('Individual addition')
                    console.log('individual')
  
                  }
                  else if(arr.length==3){
                    var myarr = arr[0].split(',')
                    console.log(myarr)
                    var n = myarr[0].split(':')
                    setnum1(n[1])
                    setnum2(myarr[1])
                    myarr = arr[1].split(',')
                    setnum3(myarr[0])
                    setnum4(myarr[1])
                    myarr = arr[2].split(',')
                    setnum5(myarr[0])
                    setnum6(myarr[1])
                    setaddition('Pairwise addition')
                    setterm('... upto 20 terms')
                    console.log('pairwise')
  
                  }
            
                }
              
                
                if(activity.analysis.length=='0'){
                  setmytime('')
                  setmyspace('')
                }
                else{
                  setmytime(activity.analysis[0].timeText)
                  setmyspace(activity.analysis[0].spaceText)
                }
              
              setloading(false)
            }
            else{
            var question='Write an algorithm to find sum of first 40 odd numbers such as 1+3+5+7+…+n=79(40th term)'
           
            if(resp.data.activity2[0].problemStatement==''){
              resp.data.activity2[0].problemStatement=question
            }
            resp.data.currentActivity='activity2'
              
            console.log('updating profile')
            const data=
            {
              profile: resp.data
            }    
          
          axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
          .then((response) =>{
            //console.log(response.data)
            settotaldata(response.data)
            const activity = response.data.activity2[0]

            //console.log(activity)
              setmydata(activity)
           settotaldata(response.data)
              if(activity.decomposition.length=='0'){
                setmydeco('')
                setmydeco1('')
                setmydeco2('')
              }
              else{
                var arr = activity.decomposition[0].userText.split('+')
                //console.log(arr.length)
                if(arr.length==7){
                  
                  var n = arr[0].split(':')
                  setnum1(n[1])
                  setnum2(arr[1])
                  setnum3(arr[2])
                  setnum4(arr[3])
                  setnum5(arr[4])
                  setnum6(arr[5])
                  setaddition('Individual addition')
                  console.log('individual')

                }
                else if(arr.length==3){
                  var myarr = arr[0].split(',')
                  console.log(myarr)
                  var n = myarr[0].split(':')
                  setnum1(n[1])
                  setnum2(myarr[1])
                  myarr = arr[1].split(',')
                  setnum3(myarr[0])
                  setnum4(myarr[1])
                  myarr = arr[2].split(',')
                  setnum5(myarr[0])
                  setnum6(myarr[1])
                  setaddition('Pairwise addition')
                  setterm('... upto 20 terms')
                  console.log('pairwise')

                }
              }
           
              if(activity.analysis.length=='0'){
                setmytime('')
                setmyspace('')
              }
              else{
                setmytime(activity.analysis[0].timeText)
                setmyspace(activity.analysis[0].spaceText)
              }

                // try{
                //         getData(sessid)
                //         interval = setInterval(() => {
                //             //console.log('Interval is working')
                //             getData(sessid);
                //             updateCount(user.count)
                //         }, 3000);
                
                   
                //   } catch (error) {
                //       if (axios.isCancel(error)) {
                //         console.log("cancelled");
                //       } else {
                //         throw error;
                //       }
                //     }

            
            setloading(false)
            

          })
          .catch((error)=>{
            console.log(error);
            });
          }
          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })


  const LevenshteinDistance = (s1, s2) => {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array(s2.length + 1);
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i == 0) {
                costs[j] = j;
            } else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1)) {
                        newValue = Math.min(Math.min(newValue, lastValue),
                                costs[j]) + 1;
                    }
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0) {
            costs[s2.length] = lastValue;
        }
    }
    return costs[s2.length];
  }

  const similarity=(s1, s2) =>{
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
        return 1.0;
    }
    return (longerLength - LevenshteinDistance(longer, shorter)) / longerLength;
}

  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
     const imageVariants = {
      animateOne:{
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  repeat: finalCount,
                  duration:3,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      },
      animateTwo:{
        x: [0, 499],
        //y: [0, -30],
        transition: {
            x:{
                repeat: finalCount,
                duration:3,
                ease:"easeOut"
            },
            // y:{
            //     yoyo: Infinity,
            //     duration:0.25,
            //     ease:"easeOut"
            // },
        }
      }
    }

   

     const imgVariants = {
      hidden:{ opacity: 0},
      visible:{
        opacity: 1,  
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  yoyo: myCount,
                  duration:1,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      }
    }

    const Notification = (act) => {

      var query=totaldata.support.filter((ses)=> ses.activity == act)
      console.log(query)
      const length = query.length;
      //console.log(length)
      ///check for new queries
      var newQuery = false;    

      if(length>0 && typeof(query)!='undefined' && typeof(length)!='undefined'){
        const lastMsg = new Date(query[length-1].created)
        const lastVisit = new Date(totaldata.lastViewStudentSupport)
      
        if(lastVisit < lastMsg){
          newQuery = true
        }
      }
        console.log(newQuery)
        
          return newQuery

    }
    const handleCountChange = (event) =>{
      var count = event.target.value
      setmyCount(count)
      //console.log(event.target.value)
    }

    const getText = () =>{
                
     var mytext = ''
    var myarr = mydata.decomposition[0].userText.split('+')
    myarr.map((text, index)=>{
      var newArr = text.split(',')
      mytext = mytext+"("+newArr[0]+'+'+newArr[1]+")+"
    })
    mytext = 'Pairwise addition: '+mytext+'upto 20 terms'
    /////console.log(mytext)          
      return(
            <>{mytext}</>
      );
    }
    const getaltdecoText = () =>{
                
      var mytext = ''
     var myarr = mydata.decomposition[0].userText.split('+')
     if(myarr[0].includes(',')==true){
      myarr.map((text, index)=>{
        var newArr = text.split(',')
        mytext = mytext+"("+newArr[0]+'+'+newArr[1]+")+"
      })
      mytext = 'Pairwise addition: '+mytext+'upto 20 terms'
     }
     else{
      mytext = 'Individual addition: '+mydata.decomposition[0].userText
     }
    
     /////console.log(mytext)          
       return(
             <>{mytext}</>
       );
     }

    const getPatternText = () =>{
                
      var mytext = ''
      var newArr = mydata.pattern[0].userText.split(',')
      if(mydata.pattern[0].completed==false){
        mytext = 'Total sum: '+newArr[0]+newArr[1]+newArr[2]+newArr[3]+newArr[4]+newArr[5]+newArr[6]+newArr[7]
      }
      else{
        mytext = 'Total sum: '+newArr[0]+newArr[1]+newArr[2]
      }
     /////console.log(mytext)          
       return(
             <>{mytext}</>
       );
     }
     const solutionIndex = () =>{
       var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
        len=len+mydata.algorithm[0].alternateSolution.length
      }
      return len;
     }

      var abstractionList = [
        { label: 'n', value: 'n' },
      { label: abs2, value: abs2 },
      { label: '2n', value: '2n' },
      { label: '', value: '' }
    ];


    

    var setList = [
      { label: 'n', value: 'n' },
      { label: algo3, value: algo3 },
      { label: '2*n', value: '2*n' },
      { label: '', value: '' }
    ];


    var VarList = [
      {label: 'n', value: 'n'}, {label: 'o', value: 'o'}, {label: 'p', value: 'p'}, {label: 'sum', value: 'sum'}, 
      {label: 'area', value: 'area'}, {label: 'count', value: 'count'}, {label: 'var1', value: 'var1'},
      {label: 'l', value: 'l'}, {label: 'k', value: 'k'}, {label: 'x', value: 'x'},
      {label: 'y', value: 'y'}]

      var setVarList = [ { label: abs1, value: abs1 },
        {label: 'n', value: 'n'}, {label: 'o', value: 'o'}, {label: 'p', value: 'p'}, {label: 'sum', value: 'sum'},
        {label: 'area', value: 'area'}, {label: 'count', value: 'count'}, {label: 'var1', value: 'var1'},
        {label: 'l', value: 'l'}, {label: 'k', value: 'k'}, {label: 'x', value: 'x'}, {label: 'y', value: 'y'} ]

    const handleAbsChange1 = (event) =>{
      setabs1(event.target.value)
    }
    const handleAbsChange2 = (event) =>{
      setabs2(event.target.value)
    }
    const handleAbsChange3 = (event) =>{
      setabs3(event.target.value)
    }
    const handleAbsChange4 = (event) =>{
      setabs4(event.target.value)
    }
    const handleAbsChange5 = (event) =>{
      setabs5(event.target.value)
    }
    const handleAbsChange6 = (event) =>{
      setabs6(event.target.value)
    }
    const handleAbsChange7 = (event) =>{
      setabs7(event.target.value)
    }
    const handleAbsChangeNum = (event) =>{
      setabsNum(event.target.value)
    }
    
    
    

    const submitCount = () => {
      //console.log(myCount)
      dispatch(
        upCount(0)
      )
      
      var count = 2*myCount-1
      dispatch(
        finCount(count)
      )
      setfinalCount(count)
      cycleAnimation()
      //clearInterval(interval);


    }

    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    const closeModalYesThree=()=>{
      
      var answerCorrect=false
      
      setmyModalThree(!myModalThree)
    
      
      if(activeStep==0){
        setansType('')

        var decompos=""

        if(addition==='Individual addition'){
          decompos = addition+':'+num1+'+'+num2+'+'+num3+'+'+num4+'+'+num5+'+'+num6+'+'+term
        }
        else if(addition==='Pairwise addition'){
          decompos = addition+':'+num1+','+num2+'+'+num3+','+num4+'+'+num5+','+num6+','+term
        } 
               
        mydata.decomposition[0].userText=decompos
        mydata.decomposition[0].noOfattempts=mydata.decomposition[0].noOfattempts+1
        arrStore.map((val, index)=>{
          mydata.decomposition[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity2',
          decomposition:mydata.decomposition,
          problem: 'oddS1ton' 
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity2[0]
          setmydata(activity)
           settotaldata(response.data)
          answerCorrect=activity.decomposition[0].completed
          
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          
          
            if(activity.decomposition[0].proceed===true){
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")
              if(answerCorrect===false){
                
                  setmypattern(mydata.pattern[0].userText)
                  setpatnum1('')
                  setpatnum2('')
                  setpatnum3('')
                  setpatnum4('')
                  setpatnum5('')
                  setpatnum6('')
                  setpatnum7('')
                  setpatnum8('')

                }
              else{
                console.log('Going to'+activeStep) 
                setmypattern(mydata.pattern[0].userText)
                setpatnum1('')
                setpatnum2('')
                setpatnum3('')
                setpatnum4('')
                setpatnum5('')
                setpatnum6('')
                setpatnum7('')
                setpatnum8('')
              }
            }
            else{
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                if(activity.decomposition[0].noOfaltattempts<4){
                  setansType('Incorrect Answer. Try to connect your response to the previous step..')
                }
                else{
                  if(activity.altStep=='decomposition'){
                      setaltHint(activity.decomposition[0].hints[0].alternate)
                    }
                  else if(activity.altStep=='pattern'){
                      setaltHint(activity.pattern[0].hints[0].alternate)
                    }
                  else if(activity.altStep=='abstraction'){
                      setaltHint(activity.abstraction[0].hints[0].alternate)
                    }
                }               
              }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }
            }

          setisSubmit(false) 
          setmyModalTwo(!myModalTwo)    ////code for hints modal
          seterror('')

      })
            

      }

      if(activeStep==1){

        var err=false
        if(patnum1===''){
          err=true
        }
        else if(patnum2===''){
          err=true
        }
        else if(patnum3===''){
          err=true
        }
        if(err===false){
          seterror('')
        if(mydata.decomposition[0].completed===false){
          mydata.pattern[0].userText=patnum1+','+patnum2+','+patnum3+','+patnum4+','+patnum5+','+patnum6+','+patnum7+','+patnum8
        }
        else{
          mydata.pattern[0].userText=patnum1+','+patnum2+','+patnum3+','+patnum4+','+patnum5+','+patnum6+','+patnum7+','+patnum8
          if(patnum1!='' && patnum2!='' && patnum3!='' && patnum4=='' && patnum5==''&& patnum6==''){
            if(patnum1==80){
                mydata.pattern[0].userText1=''
            }
            else{
                mydata.pattern[0].userText1='Pairwise_sum!=80'
            }
            if(patnum3==20){
                mydata.pattern[0].userText2=''
            }
            else{
                mydata.pattern[0].userText2='Pair_count!=20'
            }
          }
          if(mydata.pattern[0].levelOfHints==='Intermediate'|| mydata.pattern[0].levelOfHints==='Advanced'){
            mydata.pattern[0].userText=patnum1+','+patnum2+','+patnum3
            if(patnum1==80){
                mydata.pattern[0].userText1=''
            }
            else{
                mydata.pattern[0].userText1='Pairwise_sum!=80'
            }
            if(patnum3==20){
                mydata.pattern[0].userText2=''
            }
            else{
                mydata.pattern[0].userText2='Pair_count!=20'
            }
          }
        }
        mydata.pattern[0].noOfattempts=mydata.pattern[0].noOfattempts+1
        ///mydata.pattern[0].userText=mypattern
        //mydata.pattern[0].userText1=mypattern1
        if(mydata.altStep==='decomposition'){
          var len = mydata.decomposition[0].alternateSolution.length-1;
          if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
            mydata.pattern[0].noOfattempts=0
            mydata.pattern[0].noOfaltattempts=mydata.pattern[0].noOfaltattempts+1
          }
        }
        else if(mydata.altStep==='pattern'){
          var len = mydata.pattern[0].alternateSolution.length-1;
          if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
            mydata.pattern[0].noOfattempts=0
            mydata.pattern[0].noOfaltattempts=mydata.pattern[0].noOfaltattempts+1
          }
        }
        arrStore.map((val, index)=>{
          mydata.pattern[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity2',
          pattern: mydata.pattern,
          problem: 'oddS1ton' 
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity2[0]
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          setmydata(activity)
           settotaldata(response.data)
          
            if(activity.pattern[0].proceed===true){
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")
              if(activity.pattern[0].completed===false){
                var text = mydata.pattern[0].userText.split(',')
                var pat = text[0]+text[1]+text[2]+text[3]+text[4]+text[5]+text[6]+text[7]
                setabs1('')
                setabs2(pat)
              }
              else{
                console.log('Going to'+activeStep)
                               
              }
            }
            else{
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                if(activity.pattern[0].noOfaltattempts<4){
                  setansType('Incorrect Answer. Try to connect your response to the previous step..')
                }
                else{
                  if(activity.altStep=='decomposition'){
                      setaltHint(activity.decomposition[0].hints[0].alternate)
                    }
                  else if(activity.altStep=='pattern'){
                      setaltHint(activity.pattern[0].hints[0].alternate)
                    }
                  else if(activity.altStep=='abstraction'){
                      setaltHint(activity.abstraction[0].hints[0].alternate)
                    }
                }               
              }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }

            }
         
          
            setisSubmit(false)
            setmyModalTwo(!myModalTwo) ////code for hints modal
            seterror('')
  
        })
        }
        else{
          setisSubmit(false)
          seterror('Please enter text/number/operators in above space')
        }

      }

      if(activeStep==2){
        setansType('')
        var err=''        
        if(mydata.pattern[0].completed===false){
          if(abs1===''){
            err='please enter text into the space above'
            seterror(err)
          }
          mydata.abstraction[0].userText=abs1
        
        }
        else{
          if(abs1===''){
            err='please enter text into the space above'
            seterror(err)
          }
          var code=''
          code = `n=${absNum};sum=0;sum=n*n;return sum`
          const F = new Function(code);          
          var out = F()
          mydata.abstraction[0].userText='(,'+abs1+','+abs2+','+abs3+',),'+abs4+',(,'+abs5+','+abs6+','+abs7+',)'
          if(out==CalculateOddSum() && abs2=='*'){
            mydata.abstraction[0].userText1=''
          }
          else{
            mydata.abstraction[0].userText1='sum=n+n'
          }
          
          mydata.abstraction[0].noOfattempts=mydata.abstraction[0].noOfattempts+1
          err=error
        }
        
        if(err===''){
        if(mydata.altStep==='decomposition'){
          var len = mydata.decomposition[0].alternateSolution.length-1;
          if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
            mydata.abstraction[0].noOfattempts=0
            mydata.abstraction[0].noOfaltattempts=mydata.abstraction[0].noOfaltattempts+1
          }
        }
        else if(mydata.altStep==='pattern'){
          var len = mydata.pattern[0].alternateSolution.length-1;
          if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
            mydata.abstraction[0].noOfattempts=0
            mydata.abstraction[0].noOfaltattempts=mydata.abstraction[0].noOfaltattempts+1
          }
        }
        arrStore.map((val, index)=>{
          mydata.abstraction[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity2',
          abstraction: mydata.abstraction,
          problem: 'oddS1ton' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity2[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          if(activity.abstraction[0].proceed===true){
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            console.log('Going to'+activeStep)
            var setsum=commaToText(mydata.abstraction[0].userText)
            setansType("Correct Answer Bravo!! Let's move to next")
            if(activity.abstraction[0].completed===false){
              console.log('Not completed')
              setalgo2('') 
              setalgo3('') 
              setalgo4('') 
              setalgo3(setsum)
            }
            else{
              console.log('Going to'+activeStep)                  
              setabs1(setsum)
              setmyalgo3('')
            }
          }
          else{
            if(step===''){
              setansType('Incorrect Answer.')
            }
            else if(step!=='' && altcompleted==false){
              if(activity.abstraction[0].noOfaltattempts<4){
                setansType('Incorrect Answer. Try to connect your response to the previous step..')
              }
              else{
                if(activity.altStep=='decomposition'){
                    setaltHint(activity.decomposition[0].hints[0].alternate)
                  }
                else if(activity.altStep=='pattern'){
                    setaltHint(activity.pattern[0].hints[0].alternate)
                  }
                else if(activity.altStep=='abstraction'){
                    setaltHint(activity.abstraction[0].hints[0].alternate)
                  }
              }             
            }
            else if(step!=='' && altcompleted==true){
              setansType('Can you change your answer? Try following hint.')
            }

          }
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')

        })

      }
      else{
        setisSubmit(false)
        seterror('Please enter text/number/operators in above space')
      }

    }

      if(activeStep==3){
        setansType('')
        var err=''
        if(mydata.abstraction[0].completed===false){
          if(myalgo==='' || myalgo1==='' || myalgo2==='' || myalgo3===''){
            err='please enter text in spaces above'
            seterror(err)
          }
          else if(myalgo1!== myalgo2){
            err='set variable '+myalgo2+' should be equal to define variable '+myalgo1
            seterror(err)
          }
          else if(myalgo4!== myalgo2){
            err='please ensure that output variable '+myalgo4+' is equal to set variable '+myalgo2
            seterror(err)
          }
          mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
          mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
          if(1600!=CalculateAltOutput()){
            mydata.algorithm[0].userText1='incorrect answer'
          }
          mydata.algorithm[0].userText2=''
          mydata.algorithm[0].userText3=''
          mydata.algorithm[0].noOfattempts=mydata.algorithm[0].noOfattempts+1
        }
        else{
          code = `n=${absNum};sum=0;sum=n*n;return sum`
          const F = new Function(code);          
          var out = F()
          mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
          mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
          
          if(out!=CalculateOutput()){
            mydata.algorithm[0].userText1='incorrect answer'
        }
        if(myalgo1===myalgo){
            mydata.algorithm[0].userText2='define n'
        }
        else{
            mydata.algorithm[0].userText2=''
        }
        if(myalgo4==myalgo){
            mydata.algorithm[0].userText3='output n'
        }
        else{
            mydata.algorithm[0].userText3=''
        }
        if(myalgo3==myalgo){
            mydata.algorithm[0].userText4='set sum to n'
        }
        else{
            mydata.algorithm[0].userText4=''
        }
          mydata.algorithm[0].noOfattempts=mydata.algorithm[0].noOfattempts+1
          
          err=error
          console.log(error)
        }
        if(err===''){
          if(mydata.altStep==='decomposition'){
            var len = mydata.decomposition[0].alternateSolution.length-1;
            if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='pattern'){
            var len = mydata.pattern[0].alternateSolution.length-1;
            if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='abstraction'){
            var len = mydata.abstraction[0].alternateSolution.length-1;
            if(mydata.abstraction[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          arrStore.map((val, index)=>{
            mydata.algorithm[0].enteredSolution.push(val)
          })
        const data=
        {
          act:'activity2',
          algorithm: mydata.algorithm,
          problem: 'oddS1ton',
          output: myalgo+'=60'+';'+myalgo1+'=0'+';'+myalgo2+'='+myalgo3+';print('+myalgo4+')' 

        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity2[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          if(activity.algorithm[0].proceed===true){
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            console.log('Going to'+activeStep)
            setansType("Correct Answer Bravo!! Let's move to next")
            if(activity.algorithm[0].completed===false){
              setmyspace(mydata.analysis[0].spaceText)
              setmytime(mydata.analysis[0].timeText) 
            }
            else{
              console.log('Going to'+activeStep)
              setmyspace(mydata.analysis[0].spaceText)
              setmytime(mydata.analysis[0].timeText) 
            }
          }
          else{
            if(step===''){
              setansType('Incorrect Answer.')
            }
            else if(step!=='' && altcompleted==false){
              if(activity.algorithm[0].noOfaltattempts<4){
                setansType('Incorrect Answer. Try to connect your response to the previous step..')
              }
              else{
                if(activity.altStep=='decomposition'){
                    setaltHint(activity.decomposition[0].hints[0].alternate)
                  }
                else if(activity.altStep=='pattern'){
                    setaltHint(activity.pattern[0].hints[0].alternate)
                  }
                else if(activity.altStep=='abstraction'){
                    setaltHint(activity.abstraction[0].hints[0].alternate)
                  }
              }             
            }
            else if(step!=='' && altcompleted==true){
              setansType('Can you change your answer? Try following hint.')
            }

          }
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')          

      })
        }
        else{
          setisSubmit(false)
          setansType('see the error and change text/variable accordingly')
          setmyModalTwo(!myModalTwo)      }

      }

      if(activeStep==4){
        setansType('')
        var err = ''
        if(myspace==''||myspace==' '){
          err='Please enter the no. of variables used'
        }
        else if(mytime==''||mytime==' '){
          err='Please enter the no. of operations used'
        }

        mydata.analysis[0].spaceText=myspace
        mydata.analysis[0].timeText=mytime
        mydata.analysis[0].noOfattempts=mydata.analysis[0].noOfattempts+1

        
        if(err===''){
          if(mydata.altStep==='decomposition'){
            var len = mydata.decomposition[0].alternateSolution.length-1;
            if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='pattern'){
            var len = mydata.pattern[0].alternateSolution.length-1;
            if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='abstraction'){
            var len = mydata.abstraction[0].alternateSolution.length-1;
            if(mydata.abstraction[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='algorithm'){
            var len = mydata.algorithm[0].alternateSolution.length-1;
            if(mydata.algorithm[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }

          arrStore.map((val, index)=>{
            mydata.analysis[0].enteredSolution.push(val)
          })
        const data=
        {
          act:'activity2',
          analysis: mydata.analysis,
          problem: 'oddS1ton' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity2[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            else if(step=='algorithm'){
              var len = activity.algorithm[0].alternateSolution.length-1;
              var altcompleted = activity.algorithm[0].alternateSolution[len].algoCompleted
            }
          }
            if(activity.analysis[0].proceed===true){
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log('Going to'+activeStep)
              if(activity.analysis[0].completed==false){
                setansType(' Your answer is correct but not the best. Try going back and change your solution to improve your solution.')
              }
              else{
                setansType('Correct Answer Bravo!!! The solution takes minimum operations')
              }
              
            }
            else{              
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                  if(activity.analysis[0].noOfaltattempts<4){
                      setansType('Incorrect Answer. Try to analyse the algorithm developed in the previous step..')
                    }
                    else{
                      if(activity.altStep=='decomposition'){
                          setaltHint(activity.decomposition[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='pattern'){
                          setaltHint(activity.pattern[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='abstraction'){
                          setaltHint(activity.abstraction[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='algorithm'){
                          setaltHint(activity.algorithm[0].hints[0].alternate)
                        }
                    }            
                  }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }
            }    
            setisSubmit(false)      
            setmyModalTwo(!myModalTwo)
            seterror('')
      })
    }
    else{
      setisSubmit(false)
      setansType(err)
      setmyModalTwo(!myModalTwo)

    }
  }
  if(activeStep==5){
    setansType('')
    const data=
        {
          act:'activity2',
          comparison: mydata.comparison,
          problem: 'oddS1ton' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity2[0]
          setmydata(activity)
           settotaldata(response.data)
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setmyModalTwo(!myModalTwo) ////code for hints modal 
          var len=0
          if(typeof(activity.decomposition[0].alternateSolution.length)!='undefined'){
            len=activity.decomposition[0].alternateSolution.length
          }
          if(typeof(activity.pattern[0].alternateSolution.length)!='undefined'){
            len=len+mydata.pattern[0].alternateSolution.length
          }
          if(typeof(activity.abstraction[0].alternateSolution.length)!='undefined'){
            len=len+activity.abstraction[0].alternateSolution.length
          }
          if(typeof(activity.algorithm[0].alternateSolution.length)!='undefined'){
            len=len+activity.algorithm[0].alternateSolution.length
          }
          if(typeof(activity.comparison[0].alternateSolution.length)!='undefined'){
            len=len+activity.comparison[0].alternateSolution.length
          }
          var list = new Array(len+1)
          for(let i=0; i<list.length;i++){
            var num=i+1
              list[i] = {
                'label':'solution'+num,
                'value':'solution'+num
              };
            }
            setsollist(list)
            setmycomsol(mydata.comparison[0].userText1) 
            setmycomsol1(mydata.comparison[0].userText2) 
            setmycomsol2(mydata.comparison[0].userText4) 
            setmycomsol3(mydata.comparison[0].userText5)
            setisSubmit(false) 
           setExpanded1('panel12')
           setmyModalTwo(!myModalTwo) ////code for hints modal
      })
    }
    if(activeStep==6){
      
      var empty = true;
      if(mycomsol !== '' && mycomsol2 !== '' && mycomsol1!=='' && mycomsol3!==''){
        empty=false
      }
       if(empty===true){
          setisSubmit(false)        
          seterror('Please enter text above')
        }
        else{
            seterror('')
            mydata.comparison[0].userText='Which of the solution do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='Your system can only perform maximum 5 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3
            arrStore.map((val, index)=>{
              mydata.comparison[0].enteredSolution.push(val)
          })
            const data=
            {
              act:'activity2',
              comparison:mydata.comparison,
              submit:true
            }                     
            console.log(data)
      
          axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
          .then((response) => {
              console.log(response.data)
              const activity = response.data.activity2[0]
              setmydata(activity)
           settotaldata(response.data)
              setisSubmit(false)        
              movedat('activity2','activity3','correct')
              history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/analytics/2`)
        })
      }
    }
    
          
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)
      setisSubmit(false)
    }

    


    // console.log(mydata.decomposition)

    function getStepContent(step) {
      switch (step) {
        case 0:
          return 'decomposition' ;
        case 1:
          return 'pattern';
        case 2:
          return 'abstraction';
        case 3:
          return 'algorithm';
        case 4:
          return 'analysis';
        case 5:
          return 'solution';
        case 6:
          return 'comparison';
        case 7:
          return 'activity3';
        default:
          return 'unknown';
      }
    }
    
    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity2[0]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity)
           settotaldata(response.data)
           
  
      })
    
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false;

    if(activeStep==0 && mydata.decomposition[0].proceed===true){
      
      console.log('Going next Completed decomposition')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.decomposition[0].completed===true){
        if(mydata.pattern.length!=='0'){ 
          if(mydata.pattern[0].userText!==''){
            var arr = mydata.pattern[0].userText.split(',')
            //console.log(arr.length)
              setpatnum1(arr[0])
              setpatnum2(arr[1])
              setpatnum3(arr[2])
              setpatnum4(arr[3])
              setpatnum5(arr[4])
              setpatnum6(arr[5])
              setpatnum7(arr[6])
              setpatnum8(arr[7])
          }
          else{
            setpatnum1('')
            setpatnum2('')
            setpatnum3('')
            setpatnum4('')
            setpatnum5('')
            setpatnum6('')
            setpatnum7('')
            setpatnum8('')
          }
          setmypattern(mydata.pattern[0].userText)
          setmypattern1(mydata.pattern[0].userText1)
        }
    }
    else{
      if(mydata.pattern[0].userText!==''){
        var arr = mydata.pattern[0].userText.split(',')
        //console.log(arr.length)
          setpatnum1(arr[0])
          setpatnum2(arr[1])
          setpatnum3(arr[2])
          setpatnum4(arr[3])
          setpatnum5(arr[4])
          setpatnum6(arr[5])
          setpatnum7(arr[6])
          setpatnum8(arr[7])
      }
    }
      comp=true;
    }
    else if(activeStep==1 && mydata.pattern[0].proceed===true){
      console.log('Going next Completed pattern')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.pattern[0].completed===true){
        if(mydata.abstraction[0].userText!==''){
          var newArr = mydata.abstraction[0].userText.split(',')
          setabs1(newArr[1])
          setabs2(newArr[2])
          setabs3(newArr[3])
          setabs4(newArr[5])
          setabs5(newArr[7])
          setabs6(newArr[8])
          setabs7(newArr[9])
        }
      }
      else{
        var text = mydata.pattern[0].userText.split(',')
        var pat = text[0]+text[1]+text[2]+text[3]+text[4]+text[5]+text[6]+text[7]
        setabs2(pat)
        setabs1(mydata.abstraction[0].userText)

     }

      comp=true;

    }
    else if(activeStep==2 && mydata.abstraction[0].proceed===true){
      console.log('Going next Completed abstraction')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      var setsum= commaToText(mydata.abstraction[0].userText)

      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.abstraction[0].completed===false){
        
        if(mydata.algorithm[0].userText!==''){
        var arr = mydata.algorithm[0].userText.split(';')
        var inputArr = arr[0].split(',')
        if(inputArr.length!==1){
          setmyalgo(inputArr[1])  
          console.log('input defined')  
        }
        else{
          console.log('input undefined')  
          setmyalgo('')    
        }
        var defineArr = arr[1].split(',')
          if(defineArr.length!==1){
            setmyalgo1(defineArr[1]) 
          }
          else{
            setmyalgo1('') 
          }
        var setArr =arr[2].split(',')
          if(setArr.length!==1){
            setmyalgo2(setArr[1])
            setmyalgo3(setArr[3])
          }
          else{
            setmyalgo2('')
            setmyalgo3('')
          }
        var outArr = arr[3].split(',')   
        if(outArr.length!==1){
          setmyalgo4(outArr[1])     
        }
        else{
          setmyalgo4('')     
        }
      }    
      setalgo3(setsum) 
      }
      else{
        
        setabs1(commaToText(mydata.abstraction[0].userText))
        
        if(mydata.algorithm[0].userText!==''){
          var arr = mydata.algorithm[0].userText.split(';')
          var inputArr = arr[0].split(',')
          if(inputArr.length!==1){
            setmyalgo(inputArr[1])  
            console.log('input defined')  
          }
          else{
            console.log('input undefined')  
            setmyalgo('')    
          }
          var defineArr = arr[1].split(',')
            if(defineArr.length!==1){
              setmyalgo1(defineArr[1]) 
            }
            else{
              setmyalgo1('') 
            }
          var setArr =arr[2].split(',')
            if(setArr.length!==1){
              setmyalgo2(setArr[1])
              setmyalgo3(setArr[3])
            }
            else{
              setmyalgo2('')
              setmyalgo3('')
            }
          var outArr = arr[3].split(',')   
          if(outArr.length!==1){
            setmyalgo4(outArr[1])     
          }
          else{
            setmyalgo4('')     
          }
        }
          
      }
    
      comp=true;

    }
    else if(activeStep==3 && mydata.algorithm[0].proceed===true){
      console.log('Going next Completed algorithm')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.algorithm[0].completed===true){
        setmyspace(mydata.analysis[0].spaceText)
        setmytime(mydata.analysis[0].timeText)     
      }
      else{
        setmyspace(mydata.analysis[0].spaceText)
        setmytime(mydata.analysis[0].timeText)

      }
      
      comp=true;
    }
    else if(activeStep==4 && mydata.analysis[0].proceed===true){
      console.log('Going next Completed Analysis')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setmyModalTwo(!myModalTwo) ////code for hints modal
  
      if(mydata.analysis[0].completed===true){
        setansType('')
        // setmyspace(mydata.analysis[0].spaceText)
        // setmytime(mydata.analysis[0].timeText)     
      }
      
      comp=true;
    }
    else if(activeStep==5 && mydata.comparison[0].completed===true){
      setExpanded1('panel12')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setmyModalTwo(!myModalTwo) ////code for hints modal 
      var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
        len=len+mydata.algorithm[0].alternateSolution.length
      }
      if(typeof(mydata.comparison[0].alternateSolution.length)!='undefined'){
        len=len+mydata.comparison[0].alternateSolution.length
      }
      var list = new Array(len+1)
      for(let i=0; i<list.length;i++){
        var num=i+1
          list[i] = {
            'label':'solution'+num,
            'value':'solution'+num
          };
        }
        setsollist(list)
        setmycomsol(mydata.comparison[0].userText1) 
        setmycomsol1(mydata.comparison[0].userText2) 
        setmycomsol2(mydata.comparison[0].userText4) 
        setmycomsol3(mydata.comparison[0].userText5) 
       
       setmyModalTwo(!myModalTwo) ////code for hints modal
       comp=true;
    }
    else if(activeStep==6 && mydata.completed===true){
      history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/analytics/2`)
      comp=true
      
    }
    
    console.log(activeStep)

   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
   }
   else{
    movedat(getStepContent(activeStep),getStepContent(activeStep+1),'completed')
    setarrStore([])
  }  

  };

  const handleBack = () => {

    movedat(getStepContent(activeStep),getStepContent(activeStep-1),'completed')
    setarrStore([])
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    console.log('Going Back to '+activeStep)
    console.log(mydata)
////Code to update the text area when click back
    if(activeStep-1==0){
      if(mydata.decomposition.length=='0'){
        setmydeco('')
      }
      else{
        setmydeco(mydata.decomposition[0].userText)
        setmydeco1(mydata.decomposition[0].userText1)
        setmydeco2(mydata.decomposition[0].userText2)

      }
    }
    else if(activeStep-1==1){
      if(mydata.pattern.length=='0'){
        setmypattern('')
        setmypattern1('')
      }
      else{
        setmypattern(mydata.pattern[0].userText)
        setmypattern1(mydata.pattern[0].userText1)
      }
    }
    else if(activeStep-1==2){
    
        setmyabstract(mydata.abstraction[0].userText)
      
    }
    else if(activeStep-1==3){
        setmyalgo(mydata.algorithm[0].userText)
    }
    else if(activeStep-1==4){
        setmytime(mydata.analysis[0].timeText)
        setmyspace(mydata.analysis[0].spaceText) 
      
    }

  };

  const commaToText = (txt) =>{
    var mytext = ''
    if(txt!='' && typeof(txt)!=='undefined'){ 
    if(txt.includes(',')==true){
      var newArr = txt.split(',')
      var i=0
      while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
            mytext=mytext+' '+newArr[i]
            i=i+1
        }  
      
       return mytext
    }
    else{
      return txt
    }
  }
  return txt
    
 }

 const algoNewToText = (txt) =>{
  var tex = txt.split(';')
  var stex=[]
  if(tex.length==4){
    if(tex[2].includes('set')==true){
      stex = tex[2].split('set')
    }
  }
  else if(tex.length>4){
    if(tex[3].includes('set')==true){
      stex = tex[3].split('set')
    }
  }
  var text = []
  stex.map((val, index)=>{
    if(index>0){
      text[index]='set'+val
    }
    else{
      text[index]=val
    }
  })
  var texti=[]
  var k=0
  text.map((val,index)=>{
    var ifText = val.split('if')
    if(ifText.length>0){
      ifText.map((value,index1)=>{
        if(index1>0){
          texti[k++]= 'if'+value
        }
        else{
          texti[k++]= value
        }
      })
    }
    else{
      texti[k++]=val
    }
  })

  var textil=[]
  k=0
  texti.map((val,index)=>{
    var whileText = val.split('while')
    if(whileText.length>0){
      whileText.map((value,index1)=>{
        if(index1>0){
          textil[k++]= 'while'+value
        }
        else{
          textil[k++]= value
        }
      })
    }
    else{
      textil[k++]=val
    }
  })
  return (<div>
      {tex.length==4?
      <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
              <b>Input statement:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
               {commaToText(tex[0])}
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
          <b>Define variable:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
               {commaToText(tex[1])} 
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
          <b>Set variable:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
            {textil.map((val, index)=>{
                return(
                <div>{commaToText(val)}</div>
                )
            })}
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
          <b>Output:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
              {commaToText(tex[3])}
          </GridItem>
      </GridContainer>:
      <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <b>Input statement:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
              {commaToText(tex[0])}
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <b>Define variable:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
              {commaToText(tex[1])} {commaToText(tex[2])}
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <b>Set variable:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
            {textil.map((val, index)=>{
              return(
                <div>{commaToText(val)}</div>
                )
            })}
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <b>Output:</b>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
              {commaToText(tex[4])}
          </GridItem>
      </GridContainer>}
      </div>
  )
}

  const algoToText = (txt) =>{
    var tex = txt.split(';')
    var stex=[]
    if(tex.length==4){
      stex = tex[2].split('set')
    }
    else{
      stex = tex[3].split('set')
    }
    return (<div>
        {tex.length==4?
        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={9}>
                 {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={9} >
                 {commaToText(tex[1])} 
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={9} >
              {stex.map((val, index)=>{
                if(index>0){
                return(
                  <div>{commaToText('set'+val)}</div>
                )
                }
                else{
                  return(
                  <div>{commaToText(val)}</div>
                  )
                }
              })}
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={9} >
                {commaToText(tex[3])}
            </GridItem>
        </GridContainer>:
        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={9}>
                {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={9} >
                {commaToText(tex[1])} {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={9} >
                {stex.map((val, index)=>{
                  if(index>0){
                  return(
                    <div>{commaToText('set'+val)}</div>
                  )
                  }
                  else{
                    return(
                    <div>{commaToText(val)}</div>
                    )
                  }
                })}
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={9} >
                {commaToText(tex[4])}
            </GridItem>
        </GridContainer>}
        </div>
    )
 }

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleAltSolution = () => {
    setarrStore([])
    setisSubmit(true)
    setaltHint('')
    setansType('Change you current solution')
    seterror('')
    if(mydata.altStep==='decomposition'){
      mydata.decomposition[0].proceed=false
      const data=
      {
        act: 'activity2',
        decomposition: mydata.decomposition
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        setmydata(activity)
           settotaldata(response.data)
        movedat('solution','decomposition','altcompleted')
        setisSubmit(false)
        setActiveStep(0);
    })
    }
    else if(mydata.altStep==='pattern'){
      mydata.pattern[0].proceed=false
      const data=
      {
        act: 'activity2',
        pattern: mydata.pattern
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        movedat('solution','pattern','altcompleted')
        setisSubmit(false)
        setmydata(activity)
        settotaldata(response.data)
        setActiveStep(1);
    })
    }
    if(mydata.altStep==='abstraction'){
      mydata.abstraction[0].proceed=false
      const data=
      {
        act: 'activity2',
        abstraction: mydata.abstraction
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        movedat('solution','abstraction','altcompleted')
        setisSubmit(false)
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(2);
    })
    }
    if(mydata.altStep==='algorithm'){
      mydata.algorithm[0].proceed=false
      const data=
      {
        act: 'activity2',
        algorithm: mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        movedat('solution','algorithm','altcompleted')
        setisSubmit(false)
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(3);
    })
    }

  }

  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleClosePreview= () => {
        setopenBoard(!openBoard)
      }

      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }

    const handleAddChange =(event)=> {
      setaddition(event.target.value)
      if(event.target.value=== 'Pairwise addition'){
        setterm('... upto 20 terms')
      }
      else{
        setterm('... upto 40 terms')
      }
    }
    const handleTermChange =(event)=> {
      setterm(event.target.value)
    }
    const handleNum1Change =(event)=> {
      setnum1(event.target.value)
    }
    const handleNum2Change =(event)=> {
      setnum2(event.target.value)
    }
    const handleNum3Change =(event)=> {
      setnum3(event.target.value)
    }
    const handleNum4Change =(event)=> {
      setnum4(event.target.value)
    }
    const handleNum5Change =(event)=> {
      setnum5(event.target.value)
    }
    const handleNum6Change =(event)=> {
      setnum6(event.target.value)
    }
    const handlePatnum1Change =(event)=> {
      setpatnum1(event.target.value)
    }
    const handlePatnum2Change =(event)=> {
      setpatnum2(event.target.value)
    }
    const handlePatnum3Change =(event)=> {
      setpatnum3(event.target.value)
    }
    const handlePatnum4Change =(event)=> {
      setpatnum4(event.target.value)
    }
    const handlePatnum5Change =(event)=> {
      setpatnum5(event.target.value)
    }
    const handlePatnum6Change =(event)=> {
      setpatnum6(event.target.value)
    }
    const handlePatnum7Change =(event)=> {
      setpatnum7(event.target.value)
    }
    const handlePatnum8Change =(event)=> {
      setpatnum8(event.target.value)
    }
    
      
    
      const CalculateSum = () => {
        var err='';
        console.log(abs4+' ,'+abs5+','+abs6+', '+abs7)
        if(abs1==='' && abs2==='' && abs3==='' && abs4==='' && abs5==='' && abs6==='' && abs7===''){
          console.log('I am here')
          err='Please enter an expression above'
        }
        else if(abs4==''&& abs5==='' && abs6!==''){
          err='Wrong expression. Please change the expression'
        }
        else if(abs4==''&& abs5==='' && abs7!==''){
          err='Wrong expression. Please change the expression'
        }
        else if(abs4==''&& abs5!=='' && abs6===''){
          err='Wrong expression. Please change the expression'
        }
        else if(abs4==''&& abs6==='' && abs5!=='' && abs7!==''){
          err='Wrong expression. Please change the expression'
        }
        else if(abs4!=='' && abs6!=='' && abs5==='' && abs7===''){
          err='Wrong expression. Please change the expression'
        }
        else if(abs6=='' && abs5!=='' && abs7!==''){
          err='Wrong expression. Please enter an operator between '+abs5+' and '+abs7
        }
        else if(abs4==='' && abs6!=='' && abs5!=='' && abs7!==''){
          err='Wrong expression. Please provide an operator between the expressions'
        }
        console.log(err)
        seterror(err)
        if(abs4===''&& abs5==='' && abs7===''){
          var mycode = '('+abs1+abs2+abs3+')'
        }
        else{
          var mycode = '('+abs1+abs2+abs3+')'+abs4+'('+abs5+abs6+abs7+')'
        }

        if(err===''){
        var data = {
          nvar:absNum,
          code: mycode
        } 
        axios.post(`${baseUrl}pyinterpreter/run`, data)
        .then((response) => {
        console.log(response.data)
        if(response.data.err){
          setmysum('Error, Please check your expression')

        }
        else{
          setmysum(response.data.message[0])

        }
        })
        }
      }

      const CalculateOddSum=()=>{
        var code=''
        if(absNum!=='' && typeof(absNum)!='undefined'){
            code=`n=${absNum}; return n`
        }    
        if(absNum!=='' && typeof(absNum)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs2)!='undefined' && typeof(abs3)!='undefined'){
            code=`n=${absNum}; sum = (${abs1}${abs2}${abs3}); return sum`
        }
        if(absNum!=='' && typeof(absNum)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs3)!='undefined' && typeof(abs2)!='undefined'){
            code=`n=${absNum};sum=(${abs1}${abs2}${abs3})${abs4}(${abs5}); return sum`
        }
        if(absNum!=='' && typeof(absNum)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs3)!='undefined' && typeof(abs2)!='undefined'){
          code=`n=${absNum};sum=(${abs1}${abs2}${abs3})${abs4}(${abs5}${abs6}${abs7}); return sum`
      }
        const F = new Function(code);  
        var out = F()
        return out
    }


    const CalculateAltOutput = () => {
      var err='';
      var mycode='return 0'
      if(myalgo===''){
        err='Please provide an input statement'
      }
      else if(myalgo1===''){
        err='Please select a new define variable'
      }
      else if(myalgo2===''){
        err='Define a set variable'
      }
      else if(myalgo3===''){
        err='set variable to a formula'
      }
      else if(myalgo4===''){
        err='please define an output variable'
      }
      else{
      var incVar = false
     // console.log(myalgo4+','+myalgo+','+myalgo1)
      if(myalgo2!='' && myalgo!=='' && myalgo1!==''){
        if(myalgo2===myalgo){
          incVar=true
        }
        else if(myalgo2===myalgo1){
          incVar=true
        }
        if(incVar===false){
          err='Setting variable to incorrect value. Please change set variable to a variable declared previously'
        }
      }
      
      var incVar2=false
      if(myalgo4!='' && myalgo2!=='' && myalgo1!=='' && myalgo!==''){
      if(myalgo4===myalgo){
        incVar2=true
      }
      else if(myalgo4===myalgo1){
        incVar2=true
      }
      else if(myalgo4===myalgo2){
        incVar2=true
      }
      if(incVar2===false){
        err='Output variable incorrect. Please change the output variable'
      }
    }
  }
      
      
      seterror(err)
      if(err===''){
        var k=0
        k=myalgo3
        if(myalgo3.includes('upto 40 terms')){
          k=1600
        }
        if(myalgo3.includes('upto 20 terms')){
          k=1600
        }
        mycode = `n=0;${myalgo}=${absNum};${myalgo1}=0;${myalgo2}=${k}; return ${myalgo4}` 
        console.log(mycode)
        const F = new Function(mycode);  
        var out = F()
        
        return out
        
        
        }
    }


      const CalculateOutput = () => {
        var err='';
        var mycode=''
        if(myalgo===''){
          err='Please provide an input statement'
        }
        else if(myalgo1===''){
          err='Please select a new define variable'
        }
        else if(myalgo2===''){
          err='Define a set variable'
        }
        else if(myalgo3===''){
          err='set variable to a formula'
        }
        else if(myalgo4===''){
          err='please define an output variable'
        }
        else{
        var incVar = false
       // console.log(myalgo4+','+myalgo+','+myalgo1)
        if(myalgo3!='' && myalgo!=='' && myalgo1!==''){
          if(myalgo3.includes(myalgo)===true){
            incVar=true
          }
          else if(myalgo3.includes(myalgo1)==true){
            incVar=true
          }
          if(incVar===false){
            err='Setting variable to incorrect value. Please change set variable to a variable declared previously'
          }
        }
        
        var incVar2=false
        if(myalgo4!='' && myalgo2!=='' && myalgo1!=='' && myalgo!==''){
        if(myalgo4===myalgo){
          incVar2=true
        }
        else if(myalgo4===myalgo1){
          incVar2=true
        }
        else if(myalgo4===myalgo3){
          incVar2=true
        }
        if(incVar2===false){
          err='Output variable incorrect. Please change the output variable'
        }
      }
    }
        
        seterror(err)
        if(err===''){

          mycode = `${myalgo}=+${absNum};${myalgo1}=0;${myalgo2}=${myalgo3}; return ${myalgo4}` 
          console.log(mycode)
          const F = new Function(mycode);  
          var out = F()
          return out
          
          
          }
      }
      
      const handleAlgorithmChange =( event )=> {
        setmyalgo(event.target.value)
      }

      const handleAlgorithmChange1 =( event )=> {
        setmyalgo1(event.target.value)
      }

      const handleAlgorithmChange2 =( event )=> {
        setmyalgo2(event.target.value)
      }

      const handleAlgorithmChange3 =( event )=> {
        setmyalgo3(event.target.value)
      }
      
      const handleAlgorithmChange4 =( event )=> {
        setmyalgo4(event.target.value)
      }

      const handleAlgorithmChange5 =( event )=> {
        setmyalgo5(event.target.value)
      }
      const compareSolutionChange =( event )=> {
        setmycomsol(event.target.value)
      }
      const compareSolutionChange1 =( event )=> {
        setmycomsol1(event.target.value)
      }
      const compareSolutionChange2 =( event )=> {
        setmycomsol2(event.target.value)
      }
      const compareSolutionChange3 =( event )=> {
        setmycomsol3(event.target.value)
      }

      const handleSpaceChange =( event )=> {
        setmyspace(event.target.value)
      }

      const handleTimeChange =( event )=> {
        setmytime(event.target.value)
      }

      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        // toolbar: {
        //   items: [
        //     'heading',
        //     '|',
        //     'bold',
        //     'italic',
        //     'link',
        //     'bulletedList',
        //     'numberedList',
        //     '|',
        //     'blockQuote',
        //     'insertTable',
        //     '|',
        //     'imageUpload',
        //     'undo',
        //     'MathType',
        //     'SpecialCharacters',
        //     'SpecialCharactersMathematical',
        //     'redo',
        //     'Subscript', 
        //     'Superscript',            
        //   ]
        // }
        // ,
        // table: {
        //   contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        // }
      }

      const buttonSelect = (len,k) =>{
        var mysol='solution'+len
        console.log(k)
        if(k=='1'){
          setmycomsol(mysol)
        }
        else if(k=='3'){
          setmycomsol2(mysol)
        }
      }

      const totalSolutionComparison =(deco,pattern,abs,algorithm,time,space,len,k,step)=>{

        const algoText = (txt) =>{
          var tex = txt.split(';')
          var ou = ''
          var out=''
          if(tex.length==4){
            ou = tex[3].split(',')
          }
          else if(tex.length>4){
            ou = tex[4].split(',')
          }
          out = ou[0]+','+ou[1]
          return (<div>
              {tex.length==4?
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                       {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                       {commaToText(tex[1])} 
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(out)}
                  </GridItem>
              </GridContainer>:
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                      {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[1])} {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[3])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(out)}
                  </GridItem>
              </GridContainer>}
              </div>
          )
        }
          return (
            <>
            <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
              
                <Card hoverable onClick={() => buttonSelect(len,k)}  sx={k=='1'?{border: "1px solid grey",backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{border: "1px solid blue",backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                      <b align="center"> Your Solution {len}</b>
                  <CardBody>
                    <b style={classes.ana}> Decomposition </b>
                    <p style={step=='decomposition'?{ ...classes.cardTitle }:null}>{commaToText(deco)}</p>
                    <b style={classes.ana}> Pattern </b>
                    <p style={step=='pattern'?{ ...classes.cardTitle }:null}>{commaToText(pattern)}</p>
                    <b style={classes.ana}> Abstraction </b>
                    <p style={step=='abstraction'?{ ...classes.cardTitle }:null}>{commaToText(abs)}</p>
                    <b style={classes.ana}> Algorithm </b>
                    <p style={step=='algorithm'?{ ...classes.cardTitle }:null}>{algoText(algorithm)}</p>
                    <b style={classes.ana}> Analysis</b>
                    <p style={classes.ana}>
                      
                      No. of operations={time},No. of variables={space}       </p>
                  </CardBody>
                </Card>
                </Link>
                {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
                <>
                    <h5>Answer 1. Why do you think it is?</h5>
                      <Field
                        component={TextField}
                        type="text"
                        variant="outlined"
                        label="Enter your answer "
                        value={mycomsol1}
                        onChange={compareSolutionChange1}
                        //validate={validateSimName}
                        fullWidth= {true} 
                        //style = {{width: 340}}
                      />                                    
                  </>
                :null}
                 {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
              </>              
              );
            }



const solutionComparison =(algorithm,analysis,len,k)=>{

  const algoText = (txt) =>{
    var tex = txt.split(';')
          var ou = ''
          var out=''
          if(tex.length==4){
            ou = tex[3].split(',')
          }
          else if(tex.length>4){
            ou = tex[4].split(',')
          }
          out = ou[0]+','+ou[1]
    return (<div>
        {tex.length==4?
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                 {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                 {commaToText(tex[1])} 
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(out)}
            </GridItem>
        </GridContainer>:
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[1])} {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[3])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(out)}
            </GridItem>
        </GridContainer>}
        </div>
    )
  }
    return (
        <>
        <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
          <Card  onClick={() => buttonSelect(len,k)} hoverable sx={k=='1'?{border: "1px solid grey",backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{border: "1px solid blue",backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                <b align="center">(other possible solutions) Solution {len}</b>
            <CardBody>
              <b style={classes.ana}> Algorithm </b>
              <p style={classes.cardTitle}>{algoText(algorithm)}</p>
              <b style={classes.ana}> Analysis </b>
              <p style={{color:'blue'}}>
                {analysis} 
              </p>
            </CardBody>
          </Card>
        </Link>
         
        {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
              <>
                <h5>Answer 1. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol1}
                    onChange={compareSolutionChange1}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
            {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
        </>            
        );
      }
    

const submitPatternForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.pattern[0].userText=patnum1+','+patnum2+','+patnum3+','+patnum4+','+patnum5+','+patnum6+','+patnum7+','+patnum8
      //mydata.pattern[0].userText1=mypattern1
      arrStore.map((val, index)=>{
        mydata.pattern[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity2',
        pattern:mydata.pattern
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  
}


const submitAbstractionForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      if(mydata.pattern[0].completed===false){
        mydata.abstraction[0].userText=abs1
      }
      else{
        mydata.abstraction[0].userText='(,'+abs1+','+abs2+','+abs3+',),'+abs4+',(,'+abs5+','+abs6+','+abs7+',)'
      }
      arrStore.map((val, index)=>{
        mydata.abstraction[0].enteredSolution.push(val)
      })
      
      const data=
      {
        act:'activity2',
        abstraction:mydata.abstraction
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  //}
}

const submitAlgorithmForm = () =>{
  const algo = myalgo;                     
  var empty = true;
  if(myalgo !== ''|| myalgo1 !== ''|| myalgo2 !== ''|| myalgo3 !== ''|| myalgo4 !== ''|| myalgo5 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter your text')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      if(mydata.abstraction[0].completed===false){
        mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
        mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
      
      }
      else{
        mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
        mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
        
      }
      arrStore.map((val, index)=>{
        mydata.algorithm[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity2',
        algorithm:mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  }
}

const submitAnalysisForm = () =>{
  const analysis = myanalysis;                     
  var empty = true;
  if(myspace !== '' && mytime !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter a number')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.analysis[0].spaceText=myspace
      mydata.analysis[0].timeText=mytime
      arrStore.map((val, index)=>{
        mydata.analysis[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity2',
        analysis:mydata.analysis
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity2[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  }
}

const submitComparisonForm = () =>{
  var empty = true;
  if(mycomsol !== '' && mycomsol2 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter text above')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
            mydata.comparison[0].userText='Which of the solution do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='Your system can only perform maximum 5 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3
            arrStore.map((val, index)=>{
              mydata.comparison[0].enteredSolution.push(val)
          })
      const data=
      {
        act:'activity2',
        comparison:mydata.comparison
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        setarrStore([])
        const activity = response.data.activity2[0]
        setmydata(activity)
           settotaldata(response.data)
    })
  }
}

//////////////code to update student interaction 

const solutionEnter = (act,step,k) =>{

  var dat = {
    solution:k,
    altStep:mydata.altStep,
    created:Date.now(),
  }
  var newact = totaldata[act][0]
  var len = newact[step][0].enteredSolution.length
  var lastVal = newact[step][0].enteredSolution[len-1].solution

  var arrlen = arrStore.length

  if(arrStore.length>0){
    lastVal = arrStore[arrlen-1].solution
  }

  if(lastVal==k){

  }
  else{
     arrStore.push(dat)
     setarrStore(arrStore)
   
  }

}

const movedat = (sou,dest,typ) =>{

  var dat = {
    source:sou,
    destination:dest,
    altStep:mydata.altStep,
    type:typ,

  }
  const data=
  {
    act:'activity2',
    moveData:dat
  }                     
  console.log(data)

//   axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//   .then((response) => {
//     if(typ=='completed' && arrStore.length>0){
//       if(sou=='decomposition'){
//         arrStore.map((val, index)=>{
//           mydata.decomposition[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity2',
//           decomposition:mydata.decomposition
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity2[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }
//       else if(sou=='pattern'){
//         arrStore.map((val, index)=>{
//           mydata.pattern[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity2',
//           pattern:mydata.pattern
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity2[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }
//       else if(sou=='abstraction'){
//         arrStore.map((val, index)=>{
//           mydata.abstraction[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity2',
//           abstraction:mydata.abstraction
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity2[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='algorithm'){
//         arrStore.map((val, index)=>{
//           mydata.algorithm[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity2',
//           algorithm:mydata.algorithm
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity2[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='analysis'){
//         arrStore.map((val, index)=>{
//           mydata.analysis[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity2',
//           analysis:mydata.analysis
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity2[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='comparison'){
//         arrStore.map((val, index)=>{
//           mydata.comparison[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity2',
//           comparison:mydata.comparison
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity2[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }        
//     }
//     else{
//       const activity = response.data.activity2[0]
//       setmydata(activity)
//            settotaldata(response.data)
//     } 
// })
}

const history = useNavigate();


const hintGenerate =()=>{
  return(
    <div>
                          {hintsActivity1.map((text, index)=>(
                              index===activeStep?
                              <Card sx={{border: "1px solid grey"}}>
                                  <CardHeader color="success" align="center">
                                    <Typography variant="subtitle2" align="center" sx={classes.cardTitleWhite}>Hints {hintsActivity1[index].step}</Typography>
                                  </CardHeader>
                                
                                  <List sx={classes.messageArea}>
                                    {index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>Basic </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].basic}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                      {index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate'?
                                      <div>
                                      <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Intermediate</Typography>
                                          
                                        </AccordionSummary>
                                        <AccordionDetails>
                                         {mydata.decomposition[0].hints[0].intermediate}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                      {index===0 && mydata.decomposition[0].levelOfHints==='Advanced'?<div>
                                      <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Advanced</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {mydata.decomposition[0].hints[0].advanced}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                    {index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index===1 && mydata.pattern[0].levelOfHints==='Advanced' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate'?
                                  < div>
                                    <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Intermediate</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].intermediate}
                                      </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===1 && mydata.pattern[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.pattern[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  {index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==2 && mydata.abstraction[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].intermediate}
                                           
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && mydata.algorithm[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Basic' || index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && mydata.analysis[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>: null}
                                  {index==4 && mydata.analysis[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div> :null}

                                  {index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index==0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>General </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].general}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                  
                                  {index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}

                                  {index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  
                                  {index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}

                                  {index==4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Basic' || index==4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  </List>
                                  {mydata.altStep==""?'':<List sx={classes.messageArea}>
                                  {(index==1 && mydata.altStep=='decomposition' && mydata.pattern[0].noOfaltattempts>3)||(index==2 && mydata.altStep=='decomposition' && mydata.abstraction[0].noOfaltattempts>3)||(index==3 && mydata.altStep=='decomposition' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='decomposition' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.decomposition[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {(index==2 && mydata.altStep=='pattern' && mydata.abstraction[0].noOfaltattempts>3)||(index==3 && mydata.altStep=='pattern' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='pattern' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {(index==3 && mydata.altStep=='abstraction' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='abstraction' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index==4 && mydata.altStep=='algorithm' && mydata.analysis[0].noOfaltattempts>3?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                   
                                  

                                  </List>}
                                 </Card>
                                :null))}                  
              
                              </div>
  )
}

//console.log(Num)
//console.log('Deco:'+mydeco)
const handleBackActivity = () =>{
  movedat('activity2','activity1','completed')
  history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activity1${totaldata.activity1[0].level}`)
}


    return(
    loading!==true?
      <div>
          <GridContainer>
            {/* {sim()} */}
          <GridItem xs={12} sm={12} md={12}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${clas._id}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>
                                         
              <Link color="inherit" to={`/student/dashboard/viewstudentclass/${clas._id}/session/${totaldata.sessionId}/profile/${sesId}/scenario`}>
                <Typography color="textPrimary"> Scenario </Typography>
              </Link>
                <Typography color="textPrimary">Activity 2</Typography>

            </Breadcrumbs>
            {/* {console.log({...sess}.title)} */}
          </GridItem>
            <GridItem xs={12} sm={12} md={12} >
                <Button
                  //disabled={activeStep === 0}
                  onClick={handleBackActivity}
                  sx={classes.backButton}
                  >
                      Previous Activity
                </Button>
                <Typography variant="h4" align="center" sx={classes.fontLato}>
                  Password to start boat
                </Typography>
            </GridItem>

        <GridItem xs={12} sm={12} md={3} >
         
        </GridItem>
        </GridContainer>

          
            
            {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                    <GridContainer> 
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Thinking Panda' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <motion.div style={classes.modal1}>
                          <h5 style={classes.fontCursive}>Read the Instructions carefully.</h5>
                          <h5 style={classes.fontCursive}> Solve the problem to complete the activity and move forward in your mission.</h5>
                        </motion.div>
                      </GridItem>
                    </GridContainer>
                    <Button color="success" variant="contained" onClick={closeModal} 
                    title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}

                                    
          <CustomTabs
            title="Activity:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Introduction",
                tabIcon: AssignmentIcon,
                 tabContent: 
                (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}> 
                        <blockquote className="blockquote">
                                <p>
                                The boat is prepared to carry out the task at hand. The boat's captain is on a two-day leave. </p>
                                <p>You've made the decision to operate the boat due to an emergency. By pressing the power start button, you're attempting to start the boat. 
                                </p>
                                <p>The power start button that starts the boat appears to be password-protected. You looked around for a password to start the boat. Examine the problem statement to discover the password.</p>
                                
                        </blockquote>                                  
                    </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                      <img alt='Password' className="card-img-top"  height="200" src={baseUrl+'assets/images/password.jpg'} />                                  
                  </GridItem>
                </GridContainer> 
                )
              },
              {
                tabName: "Problem Statement",
                tabIcon: QuestionAnswerIcon,
                tabContent: (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <blockquote className="blockquote">
                        <p> You started searching for hints nearby to start the boat. After multiple searches you found a note nearby steering wheel.</p> 
                        <p> The note says “Password can be retrieved by adding 40 consecutive odd numbers starting from 1 to 79.</p> 
                          <p> The odd numbers are 1st= 1, 2nd term= 3, 3rd term=5, 4th term= 7 and continuing upto 40 terms. The 40th term will be 79. Add 40 terms to find the password”. </p>
                        <p>Your task is to identify the 4 digit passcode to unlock the steering wheel and start the boat to continue the mission.</p> 
                        <p> You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to retrieve the password. Your objective is defined as follows: </p>
                      </blockquote>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <img alt='oddSum1ton' className="card-img-top"  src={baseUrl+'assets/images/act2-oddsum1ton.PNG'} />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <blockquote className="blockquote">
                        <p><strong>Input: </strong>40</p><p><strong>Output: </strong>The 4-digit password is 1600 </p><p><strong>Objective: </strong> Write an algorithm to find sum of first 40 odd numbers such as 1+3+5+7+…+n=79(40th term).</p>
                      </blockquote>
                    </GridItem>
                  </GridContainer>
                  
                )                
              },
              {
                tabName: "Example",
                tabIcon: MultilineChartIcon,
                tabContent: (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={2}>
                    
                    </GridItem> 
                    <GridItem xs={12} sm={12} md={8}>
                      <blockquote className="blockquote">
                        <p><b> Example: </b> To find the sum of numbers from 2+4+8+..upto 6 terms i.e., in terms of power of 2. The sum can be written as 2^1+2^2+2^3+...+2^(n=6), where 2^n denotes 2 to the power of n i.e., 2^2=4.</p>
                        <p><b>Input: </b>n=6</p>
                        <p><b>Output: </b>Sum of n=6 numbers=126</p>
                        <b>Objective: </b> Write an algorithm to find the sum of numbers having power of 2 starting from 2+4+8+..upto 6 terms i.e., 2^1+2^2+2^3+...+2^n(n=6). 
                        <p><b> Decomposition: </b> 
                        The total sum upto 6 terms = 2+4+8+16+32+64= 126</p> 
                        <p><b> Pattern recognition: </b>
                        Observe that the next number as power of 2 greater than 126 is 128=2^7. We can write sum of 5 terms= 126= 128-2= 2^7-2</p> 
                        <p><b> Abstraction: </b>
                        Based on the pattern: sum of n=6 terms= 2^(n+1)-2.</p>  
                        <p><b> Algorithm design: </b></p>
   
                        {algoNewToText('input n;define variable sum; set sum to power(2,n+1)-2; output,sum')}
                          <b> Analysis of the algorithm: </b> 
                          <p> Number of operations: 3</p> <p> Number of variables: 1</p>
                      </blockquote>
                       
                    </GridItem>                        
                </GridContainer>
                )
                
              },
              {
                tabName: "Helpful concepts",
                tabIcon: AssignmentReturnIcon,
                tabContent: (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <blockquote className="blockquote">
                      <h3 align="center"><b>Important concepts</b></h3>
                      <img alt='ifelseHelp' className="card-img-top"  src={baseUrl+'assets/images/ifelseHelp.PNG'} />
                      <img alt='funcHelp' className="card-img-top"  src={baseUrl+'assets/images/forHelp.PNG'} />
                      <img alt='funcHelp' className="card-img-top"  src={baseUrl+'assets/images/functionHelp.PNG'} />
                      <img alt='algoHelp' className="card-img-top"  src={baseUrl+'assets/images/algoHelp.PNG'} />
                      <img alt='analysisHelp' className="card-img-top"  src={baseUrl+'assets/images/analysisHelp.PNG'} />
                    </blockquote>
                  </GridItem>                      
                </GridContainer>
                )
                
              },
              {
                tabName: "Computational Thinking Steps",
                tabIcon: SettingsApplicationIcon,
                tabContent: (
          

                  <Formik
                    initialValues={{
                    hypothesis: '',
                    }}


                    onSubmit={(values, {setSubmitting}) => {
                     setTimeout(() => {
                        setSubmitting(false);
                   
                    alert(JSON.stringify('Saving...', null, 2));

                      var decomposition = mydeco;
                      var decompos=''                     
                    
                        console.log('The term is '+term)
                        if(addition==='Individual addition'){
                          decompos = addition+':'+num1+'+'+num2+'+'+num3+'+'+num4+'+'+num5+'+'+num6+'+'+term
                        }
                        else if(addition==='Pairwise addition'){
                          decompos = addition+':'+num1+','+num2+'+'+num3+','+num4+'+'+num5+','+num6+','+term
                        }  

                        seterror('')
                        mydata.decomposition[0].userText=decomposition
                        arrStore.map((val, index)=>{
                          mydata.decomposition[0].enteredSolution.push(val)
                        })
                        const data=
                        {
                          act: 'activity2',
                          decomposition: mydata.decomposition
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity2[0]
                          setmydata(activity)
           settotaldata(response.data)
                          setarrStore([])
                      })
                     }, 500);
                    }}
                >

          {({submitForm, isSubmitting, touched, errors}) => (
          <Form>
          {loading!==true?

            <GridContainer>
                          
{/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}


{hintsActivity1.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                     
                      <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                       <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic3.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <GridContainer>
                        <motion.div style={classes.modal1}>
                          <h5 style={ansType.includes('Correct Answer')==true?{color:'green'}:{color:'red'}}> {ansType} </h5>
                          {altHint!=''?<subtitle1> AlternateHint: {altHint} </subtitle1>:null}
                          <h5 style={classes.fontMonaco}> Current Step: {hintsActivity1[index].step} 
                          {activeStep === 0?mydata.decomposition[0].proceed===true && mydata.decomposition[0].completed===false?' (Submitted)':'':
                          activeStep === 1?mydata.pattern[0].proceed===true && mydata.pattern[0].completed===false?' (Submitted)':'':
                          activeStep === 2?mydata.abstraction[0].proceed===true && mydata.abstraction[0].completed===false?' (Submitted)':'':
                          activeStep === 3?mydata.algorithm[0].proceed===true && mydata.algorithm[0].completed===false?' (Submitted)':'':
                          mydata.analysis[0].proceed===true && mydata.analysis[0].completed===false?' (Submitted)':''}

                          {activeStep === 0?mydata.decomposition[0].completed===true?' (Completed)':'':
                          activeStep === 1?mydata.pattern[0].completed===true?' (Completed)':'':
                          activeStep === 2?mydata.abstraction[0].completed===true?' (Completed)':'':
                          activeStep === 3?mydata.algorithm[0].completed===true?' (Completed)':'':
                          activeStep === 4?mydata.analysis[0].completed===true?' (Completed)':'':null} </h5>
                          {mydata.analysis[0].completed===false?<h5 style={classes.fontGaramond}> Your Task: {task[activeStep]}</h5>:null}
                          
                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.decomposition[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b>  {mydata.decomposition[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced') || (mydata.altStep==='decomposition' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b>  {mydata.decomposition[0].hints[0].advanced}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b>  {mydata.pattern[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && (index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.pattern[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && index===1 && mydata.pattern[0].levelOfHints==='Advanced') || (mydata.altStep==='pattern' && index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.pattern[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}>Basic Hint:</b> {mydata.abstraction[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced') || (mydata.altStep==='abstraction' && activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint:</b>  {mydata.abstraction[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep===''  && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.abstraction[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.algorithm[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.algorithm[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep===''  && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.algorithm[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && totaldata.type=='experiment' &&  mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.analysis[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.analysis[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.analysis[0].hints[0].advanced}           
                            </GridItem>
                          :null}
                          {/*//////////////////////////// belowfor control hint */}

                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.decomposition[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && (mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b>  {mydata.pattern[0].hints[0].general}          
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && totaldata.type=='control' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}>General Hint:</b> {mydata.abstraction[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.algorithm[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.analysis[0].hints[0].general}          
                            </GridItem>
                          :null}

                          {/*///////////////////////////////// above for control hint */}
                          
                          {activeStep===5 && mydata.analysis[0].completed===false? 
                            <GridItem xs={12} sm={12} md={12}>
                              <b style={classes.fontGaramond}> Your solution takes {mydata.analysis[0].hints[0].basic}</b>            
                            </GridItem>
                          :null}
                          {activeStep===6 ? 
                            <GridItem xs={12} sm={12} md={12}>
                                  {['1'].map((text,index)=>{
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                        len=mydata.decomposition[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.pattern[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.abstraction[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.algorithm[0].alternateSolution.length
                                      }
                                      return(
                                        <>
                                        <b style={classes.fontGaramond}>So you have implemented {len+1} solution, but there are other {mydata.comparison[0].alternateSolution.length} possible solutions.</b>
                                          <b style={classes.fontGaramond}> Observe the solutions and compare them </b> 
                                        </>
                                      )
                                  })}           
                            </GridItem>
                          :null}
                          </motion.div>
                        </GridContainer>
                          
                      </GridItem>
                         
                    </GridContainer>
                          <Button color="success" variant="contained" onClick={closeModalTwo} 
                            title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                              OK
                          </Button>
                    </motion.div>
                     
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal2}
                    variants={modal} 
                    >
                     <GridContainer>
                        {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='Marine Life' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic2.PNG'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9}>
                          <motion.div style={classes.modal2}>
                            <h4 style={classes.fontGaramond}> Are you sure you want to submit </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                No
                            </Button>
                          </motion.div>
                        </GridItem>
                      </GridContainer>
                    </motion.div>  
                </motion.div>
              </AnimatePresence>)}
    
              
           
          
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer>

                  <GridItem xs={12} sm={12} md={12}>
                    <h5 style={{...classes.fontCourier, ...{color:'blue'}}}><b>Important Instructions:</b> Read question for each step. Select the text/number below to complete the statement/equation and then click on the submit button. For any help click support button to contact your teacher</h5>
                    <Stepper activeStep={activeStep} alternativeLabel sx={{backgroundColor:'#e0e2ff'}}>

                      {steps.map((step, index) => {
                
                    return (
                      <Step key={index}>
                        <StepLabel><h5 style={classes.fontLucida}>{step}</h5></StepLabel>
                      </Step>
                      );
                      })}
                    </Stepper>
                  </GridItem>
                
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      {activeStep=='0' ?   //////Decomposition
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={8}>
                            <Card>
                              <CardHeader color="success">
                              <h5 style={classes.cardTitleWhite}> {task[0]} </h5>
                              </CardHeader>
                              <p><i>{ansType}</i></p>
                              <CardBody>
                              <GridContainer>
                                 
                                <GridItem xs={12} sm={12} md={12}>
                                <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={addition}
                                                onChange={handleAddChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 170}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {alternateList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {addition==='Pairwise addition' || addition==='Triplet addition'?
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value="("
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 35}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                              :null}
                                              
                                  
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num1}
                                                onChange={handleNum1Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              
                                              
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="+"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num2}
                                                onChange={handleNum2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {addition==='Pairwise addition'?

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value=")"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 35}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {bracketList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="+"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              {addition==='Pairwise addition' ?
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value="("
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 35}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                              :null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num3}
                                                onChange={handleNum3Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {addition==='Triplet addition'?

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                disabled={true}
                                                //label="Number"
                                                value=")"
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 35}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {bracketList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="+"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {addition==='Triplet addition' ?
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value="("
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 35}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                              :null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num4}
                                                onChange={handleNum4Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {addition==='Pairwise addition'?

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                disabled={true}
                                                //label="Number"
                                                value=")"
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 35}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {bracketList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="+"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {addition==='Pairwise addition'?

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                disabled={true}
                                                //label="Number"
                                                value="("
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 35}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {bracketList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num5}
                                                onChange={handleNum5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="+"
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={num6}
                                                onChange={handleNum6Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                              {addition==='Pairwise addition' || addition==='Triplet addition'?

                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                disabled={true}
                                                //label="Number"
                                                value=")"
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                style = {{width: 35}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {bracketList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={term}
                                                disabled={true}
                                                onChange={handleTermChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 100}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {termList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>

                                </GridItem>
                              </GridContainer>
                              </CardBody>
                            </Card>
                            {isSubmitting && <LinearProgress />}
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Save
                                </Button>
                              </GridItem> 
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                  <Card sx={{border: "1px solid black"}}>
                                    <CardHeader color="primary">
                                      <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                    </CardHeader>
                                    <CardBody>
                                      {addition=='Individual addition'?
                                      'Add individually: '+num1+'+'+num2+'+'+num3+'+'+num4+'+'+num5+'+'+num6+'+'+term:
                                      'Add pairwise: ('+num1+'+'+num2+')+('+num3+'+'+num4+')+('+num5+'+'+num6+')+'+term}
                                    </CardBody>
									                  {addition=='Individual addition'?<>
                                    {totaldata.activity1[0].decomposition[0].enteredSolution[totaldata.activity1[0].decomposition[0].enteredSolution.length-1].solution==addition+':'+num1+'+'+num2+'+'+num3+'+'+num4+'+'+num5+'+'+num6+'+'+term?
                                    null:solutionEnter('activity2', 'decomposition', addition+':'+num1+'+'+num2+'+'+num3+'+'+num4+'+'+num5+'+'+num6+'+'+term)}</>
                                    :<>{totaldata.activity1[0].decomposition[0].enteredSolution[totaldata.activity1[0].decomposition[0].enteredSolution.length-1].solution==addition+':'+num1+','+num2+'+'+num3+','+num4+'+'+num5+','+num6+','+term?
                                    null:solutionEnter('activity2', 'decomposition', addition+':'+num1+','+num2+'+'+num3+','+num4+'+'+num5+','+num6+','+term)}</>}
                                  </Card>
                                </GridItem>
                                
                                {(mydata.decomposition[0].noOfattempts>1 && mydata.decomposition[0].proceed===false)||(mydata.altStep!="" && mydata.decomposition[0].proceed===false)?
                                   <GridItem xs={12} sm={12} md={12}>
                                    <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                          onClick={ToggleHint}>    
                                          <AssistantIcon sx={{ mr: 1 }} />
                                          Hints
                                    </Fab>
                                    {loadhint === true?loading !== true?
                                      hintGenerate()
                                    :null:null}
                                  </GridItem>
                                :null}
                                
                              </GridContainer>
                            </GridItem>
                        </GridContainer>
                      </GridItem>
                          :activeStep=='1' ?    ///Pattern Recognition
                                        
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                  
                                      <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>                                    
                                      
                                       <div id="simple-modal-description" align='center'><b>Answer</b>{mydata.decomposition[0].completed==true? getText():getaltdecoText()}</div>       
                                </GridItem>
                                    
                                <GridItem xs={12} sm={12} md={8}>
                                  <Card>
                                    <CardHeader color="success">
                                      <h5 style={classes.cardTitleWhite}>{task[1]}</h5>
                                    </CardHeader>
                                    <p><i>{ansType}</i></p>
                                    <CardBody>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={3}>
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="Total sum formula:"
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'Total sum formula:',value:'Total sum formula:'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                          </Field>
                                        </GridItem> 
                                        <GridItem xs={12} sm={12} md={9}>
                                          {loading!==true?<p>
      {activeStep===1 && mydata.pattern[0].levelOfHints==='Intermediate' || activeStep===1 && mydata.pattern[0].levelOfHints==='Advanced'?

                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value="Pairwise sum="
                                                disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 35}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {pairList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                            :null}
                                            
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum1}
                                                onChange={handlePatnum1Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={patnum2}
                                                //disabled={true}
                                                onChange={handlePatnum2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
        {activeStep===1 && mydata.pattern[0].levelOfHints==='Intermediate' || activeStep===1 && mydata.pattern[0].levelOfHints==='Advanced'?
                                              <Field
                                              component={TextField}
                                              type="text"
                                              name="std"
                                              //label="Number"
                                              value="Pair count="
                                              disabled={true}
                                              //onChange={handlePatternChange}
                                              select
                                              variant="standard"
                                              //helperText="select"
                                              //style = {{width: 35}}
                                              margin="normal"
                                              InputLabelProps={{
                                                  shrink: true,
                                              }}
                                              >
                                              {pairList.map((option) => (
                                                  <MenuItem key={option.value} value={option.value}>
                                                  {option.label}
                                                  </MenuItem>
                                              ))}
                                            </Field>:null}
                                            
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum3}
                                                onChange={handlePatnum3Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
              {activeStep===1 && mydata.pattern[0].levelOfHints==='Basic' ?
                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="std"
                                            //label=""
                                            value={patnum4}
                                            //disabled={true}
                                            onChange={handlePatnum4Change}
                                            select
                                            variant="standard"
                                            helperText="select"
                                            //style = {{width: 30}}
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {operatorList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                          </Field>
                                            :null}
            {activeStep===1 && mydata.pattern[0].levelOfHints==='Basic'?

                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={patnum5}
                                                onChange={handlePatnum5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                            
            {activeStep===1 && mydata.pattern[0].levelOfHints==='Basic'?
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={patnum6}
                                                //disabled={true}
                                                onChange={handlePatnum6Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
            {activeStep===1 && mydata.pattern[0].levelOfHints==='Basic'?
                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="std"
                                            //label="Number"
                                            value={patnum7}
                                            onChange={handlePatnum7Change}
                                            select
                                            variant="standard"
                                            helperText="select"
                                            style = {{width: 45}}
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {numberList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                          </Field>:null}
            {activeStep===1 && mydata.pattern[0].levelOfHints==='Basic'?
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={patnum8}
                                                //disabled={true}
                                                onChange={handlePatnum8Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 100}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {termList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                                </p>:null}
                                          {error}
                                        </GridItem>
                                      </GridContainer>
                                    </CardBody>
                                  </Card> 
                                    <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isSubmit}
                                            onClick={submitPatternForm}
                                          >
                                            Save
                                          </Button>
                                    </GridItem> 
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <Card sx={{border: "1px solid black"}}>
                                        <CardHeader color="primary">
                                          <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                        </CardHeader>
                                        <CardBody>
                                          Total sum formula: {patnum1}{patnum2}{patnum3}{patnum4}{patnum5}{patnum6}{patnum7}{patnum8}
                                        </CardBody>
										{solutionEnter('activity2', 'pattern','Total sum formula: '+ patnum1+patnum2+patnum3+patnum4+patnum5+patnum6+patnum7+patnum8)}
                                      </Card>
                                    </GridItem>
                                    
                                    {(mydata.pattern[0].noOfattempts>1 && mydata.pattern[0].proceed===false)||(mydata.altStep!="" && mydata.pattern[0].proceed===false)?
                                    <GridItem xs={12} sm={12} md={12}>
                                    <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                          onClick={ToggleHint}>    
                                          <AssistantIcon sx={{ mr: 1 }} />
                                          Hints
                                    </Fab>
                                        {loadhint === true?loading !== true?
                                          hintGenerate()
                                      :null:null}
                                    </GridItem>:null}
                                  </GridContainer>
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            
                        </GridContainer>
                      </GridItem>

                          :activeStep=='2' ? 

                          
                            <GridItem xs={12} sm={12} md={12}>
                              <GridContainer>
                              <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                   <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                    
                                    <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].completed==true? getText():getaltdecoText()}</div>
                                  </GridItem>
                                  
                                  
                                  <GridItem xs={12} sm={12} md={12}>
                                   <p id="simple-modal-description" align="center"style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                    
                                    <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                                    
                              <GridItem xs={12} sm={12} md={8}>

                              <Card>
                                <CardHeader color="success">
                                <h4 style={classes.cardTitleWhite}> {task[2]}</h4>

                                </CardHeader>
                                <p><i>{ansType}</i></p>
                                <CardBody>
                                <GridContainer>
                                 
                                  <GridItem xs={12} sm={12} md={4}>
                                    
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="Total sum of n odd numbers:"
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'Total sum of n odd numbers:',value:'Total sum of n odd numbers:'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={8}>  
                                    
                                    {activeStep===2 && mydata.pattern[0].completed===false?
                                      <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={abs1}
                                                onChange={handleAbsChange1}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 200}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {abstractionList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>:null}
                                              {activeStep===2 && mydata.pattern[0].completed===true?
                                              <div>
                                              
                                            <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value="("
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 30}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                            </Field>
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={abs1}
                                                onChange={handleAbsChange1}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 200}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberNewList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={abs2}
                                                //disabled={true}
                                                onChange={handleAbsChange2}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={abs3}
                                                onChange={handleAbsChange3}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberNewList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                            <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value=")"
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 30}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                            </Field>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={abs4}
                                                //disabled={true}
                                                onChange={handleAbsChange4}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value="("
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 30}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                            </Field>
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={abs5}
                                                onChange={handleAbsChange5}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 200}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberNewList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={abs6}
                                                //disabled={true}
                                                onChange={handleAbsChange6}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {operatorList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={abs7}
                                                onChange={handleAbsChange7}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberNewList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field> 
                                            <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value=")"
                                                  disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  style = {{width: 30}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {bracketList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                            </Field>
                                            </div>:null}
                                        </GridItem>
                                        <p>{error}</p>
                                        
                                        {activeStep===2 && mydata.pattern[0].completed===true?
                                         <GridItem xs={12} sm={12} md={8}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value='Before submitting calculate sum for n=40: Input'
                                                disabled={true}
                                                select
                                                variant="standard"                                               
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'Before submitting calculate sum for n=40: Input',value:'Before submitting calculate sum for n=40: Input'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={absNum}
                                                onChange={handleAbsChangeNum}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 45}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field> 
                                        </GridItem> 
                                          :null}

                                          
                                      {activeStep===2 && mydata.pattern[0].completed===true? 
                                         
                                         <GridItem xs={12} sm={12} md={4}>
                                             <Field
                                                 component={TextField}
                                                 type="text"
                                                 name="std"
                                                 //label=""
                                                 value='Total sum'
                                                 disabled={true}
                                                 select
                                                 variant="standard"                                               
                                                 margin="normal"
                                                 InputLabelProps={{
                                                     shrink: true,
                                                 }}
                                                 >
                                                 {[{label:'Total sum',value:'Total sum'}].map((option) => (
                                                     <MenuItem key={option.value} value={option.value}>
                                                     {option.label}
                                                     </MenuItem>
                                                 ))}
                                             </Field>
                                             <Field
                                               component={TextField}
                                               type="text"
                                               name="std"
                                               //label=""
                                               value={CalculateOddSum()}
                                               disabled={true}
                                               //onChange={handlePatternChange}
                                               select
                                               variant="standard"
                                               //helperText="select"
                                               //style = {{width: 30}}
                                               margin="normal"
                                               InputLabelProps={{
                                                   shrink: true,
                                               }}
                                               >
                                               {[{label:CalculateOddSum(),value:CalculateOddSum()}].map((option) => (
                                                   <MenuItem key={option.value} value={option.value}>
                                                   {option.label}
                                                   </MenuItem>
                                               ))}
                                           </Field>
                                         </GridItem>
                                         
                                       :null} 
                                             
                                  
                                </GridContainer>
                                </CardBody>
                                {/* {isSubmitting && <LinearProgress />} */}
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmit}
                                    onClick={submitAbstractionForm}
                                  >
                                    Save
                                  </Button>
                                </GridItem> 
                              </GridItem>
                              <GridItem xs={12} sm={12} md={4}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                        <Card sx={{border: "1px solid black"}}>
                                          <CardHeader color="primary">
                                            <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                          </CardHeader>
                                          <CardBody>
                                            {mydata.pattern[0].completed==true?'Total sum of n odd numbers: ('+abs1+abs2+abs3+')'+abs4+'('+abs5+abs6+abs7+')':
                                            'Total sum of n odd numbers: '+abs1}                                          
                                          </CardBody>
										    
                                             {mydata.pattern[0].completed==true?solutionEnter('activity2', 'abstraction','Total sum: ('+abs1+abs2+abs3+')'+abs4+'('+abs5+abs6+abs7+')')
                                             :solutionEnter('activity2', 'abstraction','Total sum: '+abs1)}
                                        </Card>
                                  </GridItem>
                                  
                                    {(mydata.abstraction[0].noOfattempts>1 && mydata.abstraction[0].proceed===false)||(mydata.altStep!="" && mydata.abstraction[0].proceed===false)?
                                  <GridItem xs={12} sm={12} md={12}>
                                  <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                        onClick={ToggleHint}>    
                                        <AssistantIcon sx={{ mr: 1 }} />
                                        Hints
                                  </Fab>
                                        {loadhint === true?loading !== true?
                                          hintGenerate()
                                      :null:null}
                                  </GridItem>:null}
                                </GridContainer>
                              </GridItem> 
                                
                                </GridContainer>
                              </GridItem>                           
                           

                          :activeStep=='3' ?  ///Algorithm design

                           
                              <GridItem xs={12} sm={12} md={12}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].completed==true? getText():getaltdecoText()}</div>
                                      </GridItem>
                                      
                                      
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center"style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                        <p id="simple-modal-description" align="center"style={classes.ana}> Abstraction ({task[2]}) </p>
                                        
                                        <p id="simple-modal-description" align='center'><b>Answer:</b>Total sum: {commaToText(mydata.abstraction[0].userText)}</p>
                                      </GridItem>
                                      
                                    </GridContainer>
                                  </GridItem>
                                    
                                  
                                    <GridItem xs={12} sm={12} md={8}>
                                      <Card>
                                        <CardHeader color="success">
                                          <h4 style={classes.cardTitleWhite}>{task[3]}</h4>
                                        </CardHeader>
                                        <p><i>{ansType}</i></p>
                                        {error}
                                        <CardBody>
                                        <GridContainer>
                                        {loading!==true?
                                          <GridItem xs={12} sm={12} md={12}>
                                            {mydata.abstraction[0].completed===false?
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Input Statement:</h5> 
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="input"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo}
                                                      onChange={handleAlgorithmChange}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'n',value:'n'},{label:'none',value:''}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="="
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {compareList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}

                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='40'
                                                    //onChange={handleAbsChangeNum}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 45}}
                                                    margin="normal"
                                                    disabled={true}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {numberList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field> 
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Define variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="define"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo1}
                                                    onChange={handleAlgorithmChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Set variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo2}
                                                    onChange={handleAlgorithmChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo3}
                                                    onChange={handleAlgorithmChange3}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {setList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Output: </h5>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="output"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo4}
                                                      onChange={handleAlgorithmChange4}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  Odd number Sum={CalculateAltOutput()}
                                                  
                                              </GridItem>
                                                {error}
                                              </GridContainer>:  /////if abstraction completed write algorithm
                                              <GridContainer>
                                                <GridItem xs={12} sm={12} md={2}>
                                                </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                <h5>Input Statement:</h5> 
                                                <GridContainer>
                                                  <GridItem xs={12} sm={12} md={6}>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="input"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo}
                                                      onChange={handleAlgorithmChange}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {[{label:'n',value:'n'},{label:'none',value:''}].map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                  </GridItem>
                                                  <GridItem xs={12} sm={12} md={6}>
                                                    <h5>Enter Input</h5>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      label="number"
                                                      value={absNum}
                                                      onChange={handleAbsChangeNum}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 45}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {numberList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field> 
                                                  </GridItem>
                                                </GridContainer> 
                                                
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                  <h5>Define variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="define"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo1}
                                                    onChange={handleAlgorithmChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                <h5>Set variable: </h5> 
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="set"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo2}
                                                    onChange={handleAlgorithmChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="to"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={myalgo3}
                                                    onChange={handleAlgorithmChange3}
                                                    select
                                                    variant="standard"
                                                    helperText="select"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {setVarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                  
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={2}>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={10}>
                                                <h5>Output: </h5>
                                                <GridContainer>
                                                  <GridItem xs={12} sm={12} md={6}>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="output"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={myalgo4}
                                                      onChange={handleAlgorithmChange4}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                  </GridItem>
                                                  <GridItem xs={12} sm={12} md={6}>
                                                  
                                                
                                                <h5>Output= {CalculateOutput()} </h5>
                                                  </GridItem>
                                                </GridContainer>
                                                  
                                              </GridItem>
                                                {error}
                                              </GridContainer>}
                                          </GridItem>:null}
                                        </GridContainer>
                                        </CardBody>
                                        <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isSubmit}
                                            onClick={submitAlgorithmForm}
                                          >
                                            Save
                                          </Button>
                                        </GridItem>
                                      </Card>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <Card sx={{border: "1px solid black"}}>
                                            <CardHeader color="primary">
                                              <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                            </CardHeader>
                                            <CardBody>
                                              {algoNewToText('input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4)}
                                            </CardBody>
											                  {solutionEnter('activity2', 'algorithm','input '+myalgo+';define '+myalgo1+';set '+myalgo2+' to '+myalgo3+';output '+myalgo4)}
                                          </Card>
                                        </GridItem>
                                        
                                        {(mydata.algorithm[0].noOfattempts>1 && mydata.algorithm[0].proceed===false)||(mydata.altStep!="" && mydata.algorithm[0].proceed===false)?
                                        <GridItem xs={12} sm={12} md={12}>
                                        <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                              onClick={ToggleHint}>    
                                              <AssistantIcon sx={{ mr: 1 }} />
                                              Hints
                                        </Fab>
                                            {loadhint === true?loading !== true?
                                              hintGenerate()
                                          :null:null}
                                        </GridItem>:null}
                                      </GridContainer>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                            

                          :activeStep=='4' ?    ////Analysis of algorithm
                           
                              <GridItem xs={12} sm={12} md={12}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={9} sx={classes.paper}>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].completed==true? getText():getaltdecoText()}</div>
                                      </GridItem>
                                      
                                      
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center" style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                        <p id="simple-modal-description" align="center" style={classes.ana}> Abstraction ({task[2]}) </p>
                                        
                                        <p id="simple-modal-description" align='center'><b>Answer:</b>Total sum: {commaToText(mydata.abstraction[0].userText)}</p>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <p id="simple-modal-description" align="center" style={classes.ana}> Algorithm ({task[3]}) </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                            {algoNewToText(mydata.algorithm[0].userText)}
                                        </GridItem>
                                        
                                    </GridContainer>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={8}>
                                    <Card>
                                      <CardHeader color="success">
                                        <h4 style={classes.cardTitleWhite}>{task[4]} </h4>

                                      </CardHeader>
                                      <p><i>{ansType}</i></p>
                                      <CardBody>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <h5>Enter the total number of operations: </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={7}>
                                                {loading!==true?
                                                <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                label="No. of operations"
                                                value={mytime}
                                                onChange={handleTimeChange}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 200}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numberList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                                  :null}
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <h5>Enter the total number of defined variables: </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={7}>
                                                {loading!==true?
                          
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  label="No. of variables"
                                                  value={myspace}
                                                  onChange={handleSpaceChange}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numberList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                  :null}
                                              </GridItem>
                                              {error}
                                            </GridContainer>
                                          </GridItem>
                                        </GridContainer>
                                      </CardBody>
                                    </Card>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          disabled={isSubmit}
                                          onClick={submitAnalysisForm}
                                        >
                                          Save
                                        </Button>
                                    </GridItem>
                                  </GridItem>
                                  {solutionEnter('activity2', 'analysis','No. of operations '+mytime+';No. of variables '+myspace)}
                                  <GridItem xs={12} sm={12} md={4}>
                                      <GridContainer>
                                        
                                        {(mydata.analysis[0].noOfattempts>1 && mydata.analysis[0].proceed===false)||(mydata.altStep!="" && mydata.analysis[0].proceed===false)?
                                        <GridItem xs={12} sm={12} md={12}>
                                        <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                              onClick={ToggleHint}>    
                                              <AssistantIcon sx={{ mr: 1 }} />
                                              Hints
                                        </Fab>
                                            {loadhint === true?loading !== true?
                                              hintGenerate()
                                          :null:null}
                                        </GridItem>:null}
                                      </GridContainer>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                            

                          :activeStep=='5' ? 

                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                <h4 style={classes.cardTitleWhite}> Your Solution </h4>

                                </CardHeader>
                                <p><i>{ansType}</i></p>
                                <CardBody>
                                <GridContainer>
                                  {loading!==true?
                                  <GridItem xs={12} sm={12} md={12} sx={classes.paper}>
                                    
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                         <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                          
                                          <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].completed==true? getText():getaltdecoText()}</div>
                                        </GridItem>
                                        
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                         <p id="simple-modal-description" align="center" style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                          
                                          <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <p id="simple-modal-description" align="center" style={classes.ana}> Abstraction ({task[2]}) </p>
                                          
                                          <p id="simple-modal-description" align='center'><b>Answer:</b>Total sum: {commaToText(mydata.abstraction[0].userText)}</p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description" align="center" style={classes.ana}> Algorithm ({task[3]}) </p>
                                        </GridItem>
                                          <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                            {algoNewToText(mydata.algorithm[0].userText)}
                                        </GridItem>
                                          
                                          <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description" align="center" style={classes.ana}> Analysis of the algorithm </p>
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <p id="simple-modal-description"> No. of operations : {mydata.analysis[0].timeText}</p>
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={6}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <p id="simple-modal-description"> No. of variables : {mydata.analysis[0].spaceText}</p>
                                        </GridItem>
                                        
                                  </GridContainer>

                                                                     
                                  </GridItem>:null}
                                </GridContainer>
                                </CardBody>
                                {/* {isSubmitting && <LinearProgress />} */}
                              </Card>
                                
                            </GridContainer>
                          </GridItem>
                          :activeStep=='6'?
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                <h4 style={classes.cardTitleWhite}> {task[6]} </h4>

                                </CardHeader>
                                <CardBody>
                                  {error}
                                <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                  >
                                    <Typography sx={classes.heading}>Question 1</Typography>
                                    <Typography sx={classes.secondaryHeading}>
                                    Which of the solutions do you think is better?
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <GridContainer spacing={3}>
                                      {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                        if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                        if(text.algorithm.includes('nitesh')==true){
                                          var newalgo=text.algorithm.split('nitesh')
                                        }
                                        var arr = text.analysis.split(',')
                                        var newarr1=arr[0].split('=')
                                        var newarr2=arr[1].split('=')
                                        var tim = newarr1[1]
                                        var spc = newarr2[1]
                                          return (
                                            text.algoCompleted==true?
                                            
                                            <GridItem xs={12} sm={6} md={4} key={index}>
                                                {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','decomposition')}
                                            </GridItem> 
                                            :null
                                          )}})}
                                        {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                          var len=0;
                                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                            len=mydata.decomposition[0].alternateSolution.length
                                          }
                                          if(text.algorithm.includes('nitesh')==true){
                                            var newalgo=text.algorithm.split('nitesh')
                                          }
                                          var arr = text.analysis.split(',')
                                          var newarr1=arr[0].split('=')
                                          var newarr2=arr[1].split('=')
                                          var tim = newarr1[1]
                                          var spc = newarr2[1]
                                          return (
                                          text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={4} key={index}>
                                              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','pattern')}
                                          </GridItem> 
                                          :null
                                        )}})}
                                        {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                        var len=0;
                                        if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                          len=mydata.decomposition[0].alternateSolution.length
                                        }
                                        if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                          len=len+mydata.pattern[0].alternateSolution.length
                                        }
                                        if(text.algorithm.includes('nitesh')==true){
                                          var newalgo=text.algorithm.split('nitesh')
                                        }
                                        var arr = text.analysis.split(',')
                                        var newarr1=arr[0].split('=')
                                        var newarr2=arr[1].split('=')
                                        var tim = newarr1[1]
                                        var spc = newarr2[1]
                                        return (
                                        text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={4} key={index}>
                                            {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','abstraction')}
                                          </GridItem>  
                                        :null
                                        )}})}
                                        {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                          var len=0;
                                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                            len=mydata.decomposition[0].alternateSolution.length
                                          }
                                          if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                            len=len+mydata.pattern[0].alternateSolution.length
                                          }
                                          if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                            len=len+mydata.abstraction[0].alternateSolution.length
                                          }
                                          if(text.algorithm.includes('nitesh')==true){
                                            var newalgo=text.algorithm.split('nitesh')
                                          }
                                          var arr = text.analysis.split(',')
                                          var newarr1=arr[0].split('=')
                                          var newarr2=arr[1].split('=')
                                          var tim = newarr1[1]
                                          var spc = newarr2[1]
                                          return (
                                          text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={4} key={index}>
                                              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','algorithm')}
                                          </GridItem> 
                                            :null
                                          )}})}
                                          {mydata.analysis[0].completed===true?
                                                <GridItem xs={12} sm={6} md={4}>                                          
                                                    {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'1','correct')}
                                                </GridItem>             
                                          :null}

                                          {mydata.analysis[0].completed===true?
                                              
                                                  <>
                                                  {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                                    var len=0;
                                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                                      len=mydata.decomposition[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.pattern[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.abstraction[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.algorithm[0].alternateSolution.length
                                                    }
                                                    return(
                                                      <GridItem xs={12} sm={6} md={4} key={index}>
                                                        {solutionComparison(text.algorithm,text.analysis,len+index+2,'1')}
                                                      </GridItem>
                                                    )})}
                                                    </>
                                              
                                              :null}
                                      </GridContainer>
                                    </AccordionDetails>
                                </Accordion>
                            <Accordion expanded={expanded1 === 'panel13'} onChange={handleAccordionChange1('panel13')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                                >
                                  <Typography sx={classes.heading}>Question 2</Typography>
                                  <Typography sx={classes.secondaryHeading}>
                                  Your system can perform only maximum 5 operations. If you want to implement one of the solutions, which one do you think is better?
                                  </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <GridContainer spacing={3}>
                                {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                    return (
                                      text.algoCompleted==true?
                                      
                                      <GridItem xs={12} sm={6} md={4} key={index}>
                                          {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'3','decomposition')}
                                      </GridItem> 
                                      :null
                                    )}})}
                                  {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={4} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','pattern')}
                                    </GridItem> 
                                     :null
                                  )}})}
                                  {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  var len=0;
                                  if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                    len=mydata.decomposition[0].alternateSolution.length
                                  }
                                  if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                    len=len+mydata.pattern[0].alternateSolution.length
                                  }
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                  return (
                                  text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={4} key={index}>
                                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','abstraction')}
                                    </GridItem>  
                                  :null
                                  )}})}
                                  {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.pattern[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.abstraction[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={4} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','algorithm')}
                                    </GridItem> 
                                      :null
                                    )}})}
                                    {mydata.analysis[0].completed===true?
                                          <GridItem xs={12} sm={6} md={4}>                                          
                                              {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'3','correct')}
                                          </GridItem>             
                                    :null}

                                    {mydata.analysis[0].completed===true?
                                        
                                            <>
                                            {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                              var len=0;
                                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                                len=mydata.decomposition[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.pattern[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.abstraction[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.algorithm[0].alternateSolution.length
                                              }
                                              return(
                                                <GridItem xs={12} sm={6} md={4} key={index}>
                                                  {solutionComparison(text.algorithm,text.analysis,len+index+2,'3')}
                                                </GridItem>
                                              )})}
                                              </>
                                        
                                        :null}
                                    </GridContainer>
                                  </AccordionDetails>
                                </Accordion>
                                  {error}
                                </CardBody>
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmit}
                                  onClick={submitComparisonForm}
                                >
                                  Save
                                </Button>
                              </GridItem>
                            </GridContainer>
                            {solutionEnter('activity2', 'comparison','1. Better solution: '+mycomsol+',1. Reason: '+mycomsol1+'; 2. Efficient solution: '+mycomsol2+', 2. Reason: '+mycomsol3)}
                          </GridItem>
                          :null}
                      </GridContainer>
                      {loading!==true?
                      <GridContainer>
                         <GridItem xs={12} sm={12} md={9}>
                              </GridItem>
                              <GridItem xs={12} sm={12} md={3}>
                                  <div style={classes.styleChatbutton}>
                                   <Tooltip
                                    arrow
                                    title="Click for Support"
                                    placement="bottom">
                                    <Fab  color="secondary" aria-label="add" size="medium" component="span" onClick={Togglesupport}>    
                                      <ContactSupportIcon /> {Notification('activity2')==true?'1':null}
                                    </Fab>
                                    </Tooltip>
                                    <p>Support</p>
                                  </div>
                                  
                                  {loadsupport === true?loading !== true?
                                  <>
                                    <div style={classes.chatClose}>
                                      <Fab color="warning" aria-label="add" size="small" component="span" onClick={Togglesupport}>    
                                        <CloseIcon  onClick={Togglesupport}/>
                                        
                                      </Fab>
                                    </div>
                                    <div style={classes.chatContainer}>                                      
                                        <Support user = {sesId} act = 'activity2' classid = {classId}/>
                                    </div>
                                  </>
                                  :null:null} 
                                  
                              </GridItem>
                            <GridItem xs={12} sm={12} md={9}>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                            {isSubmit && <LinearProgress />}
                              <div>
                                {activeStep === steps.length-2 ? (
                                  <div>
                                    <Typography sx={classes.instructions}> Preview steps </Typography>
                                    {/* <Button onClick={handleReset}>Reset</Button> */}
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      
                                    {mydata.analysis[0].completed!==true?
                                      <Button
                                        onClick={handleAltSolution}
                                        disabled={isSubmit}
                                        variant="contained"
                                        color="primary"
                                      >
                                        Go to {mydata.altStep}
                                      </Button>
                                      :null
                                      // <Button onClick={handleClosePreview}> Preview </Button>
                                      }
                                    {mydata.analysis[0].completed==true?
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmit}
                                        onClick={handleNext}
                                      >
                                        Compare solutions 
                                      </Button>:null}
                                  </div>
                                ) : activeStep === steps.length-1 ?(
                                <div>
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                    </Button>
                                  {mydata.analysis[0].completed==true?
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      disabled={isSubmit}
                                      onClick={handleNext}
                                    >
                                      Submit Answer 
                                    </Button>:null}
                                </div>):
                                (
                                  <div>
                                    {/* <Typography sx={classes.instructions}>{getStepContent(activeStep)}</Typography> */}
                                    <div>
                                      <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      <Button variant="contained" color="primary" 
                                        disabled={isSubmit}
                                        onClick={handleNext}>
                                        {activeStep === steps.length - 3 ? 'Finish' : 'Submit and Go to Next Step'}
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </GridItem>
                      </GridContainer>:null}
                  </GridItem>

                </GridContainer>
              </GridItem>
            </GridContainer>:null}
                                                                      

          </Form>
          )}
          </Formik>
         )
                      
        },
        {
          tabName: "Previous Attempts",
          tabIcon: DeveloperBoardIcon,
          tabContent: (
            <GridItem xs={12} sm={12} md={12}>
            {mydata.analysis[0].completed===true||mydata.decomposition[0].alternateSolution.length>0||mydata.pattern[0].alternateSolution.length>0 || mydata.abstraction[0].alternateSolution.length>0?
               
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                      {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                         if(text.algorithm.includes('nitesh')==true){
                          var newalgo=text.algorithm.split('nitesh')
                        }
                          return (
                            text.algoCompleted==true?
                             
                            <div>
                              <h5 id="simple-modal-description" align='center'> Solution {index+1}  </h5>
                              <p><i> <b>Decomposition:</b> {text.decomposition}</i></p>
                              <p><b> Pattern:</b> {text.pattern}</p>
                              <p><b>Abstraction:</b> {text.abstraction}</p>

                              <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                              <p><b>Analysis:</b> {text.analysis}</p>
                            </div> :<p>Wait until you complete the current solution</p>
                          )})}
                          {mydata.pattern[0].alternateSolution.map((text, index)=>{
                            var len=0;
                            if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                              len=mydata.decomposition[0].alternateSolution.length
                            }
                            if(text.algorithm.includes('nitesh')==true){
                              var newalgo=text.algorithm.split('nitesh')
                            }
                          return (
                            text.algoCompleted==true?
                             
                            <div>
                              <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                              <p><b>Decomposition:</b> {text.decomposition}</p>
                              <p><i> <b> Pattern:</b> {text.pattern}</i></p>
                              <p><b>Abstraction:</b> {text.abstraction}</p>
                              <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                              <p><b>Analysis:</b>{text.analysis}</p>
                            </div> :<p>Wait until you complete the current solution</p>
                          )})}
                          {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                          var len=0;
                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                            len=mydata.decomposition[0].alternateSolution.length
                          }
                          if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                            len=len+mydata.pattern[0].alternateSolution.length
                          }
                          if(text.algorithm.includes('nitesh')==true){
                            var newalgo=text.algorithm.split('nitesh')
                          }
                          return (
                            text.algoCompleted==true?
                             
                            <div>
                              <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                              <p><b>Decomposition:</b> {text.decomposition}</p>
                              <p><b> Pattern:</b> {text.pattern}</p>
                              <p><i><b>Abstraction:</b>{text.abstraction}</i></p>
                              <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                              <p><b>Analysis:</b>{text.analysis}</p>
                            </div> :<p>Wait until you complete the current solution</p>
                          )})}
                          {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                            var len=0;
                            if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                              len=mydata.decomposition[0].alternateSolution.length
                            }
                            if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                              len=len+mydata.pattern[0].alternateSolution.length
                            }
                            if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                              len=len+mydata.abstraction[0].alternateSolution.length
                            }
                            if(text.algorithm.includes('nitesh')==true){
                              var newalgo=text.algorithm.split('nitesh')
                            }
                            return (
                              text.algoCompleted==true?
                              
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                <p><b>Decomposition:</b> {text.decomposition}</p>
                                <p><b> Pattern:</b> {commaToText(text.pattern)}</p>
                                <p><b>Abstraction:</b>{commaToText(text.abstraction)}</p>
                                <p><i><b>Algorithm:</b>{algoNewToText(newalgo[1])}</i></p>
                                <p><b>Analysis:</b>{text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                         {mydata.analysis[0].completed===true?
                          <div>
                            <h5 id="simple-modal-description" align='center'> Solution {solutionIndex()+1} </h5>
                            <div><b>Decomposition</b></div> {commaToText(mydata.decomposition[0].userText)}
                            <div><b>Pattern</b></div>{commaToText(mydata.pattern[0].userText)}
                            <div> <b>Abstraction</b> </div>{commaToText(mydata.abstraction[0].userText)}
                            <div><b>Algorithm</b></div> 
                            {algoNewToText(mydata.algorithm[0].userText)} 
                            <div><b>Analysis</b></div>
                            No. of operations:{mydata.analysis[0].timeText}, No. of variables:{mydata.analysis[0].spaceText} 
                          </div> :null}
                          {mydata.analysis[0].completed===true?
                          <div>
                            <h5 id="simple-modal-description" align='center'>Other possible solutions</h5>
                            
                            {mydata.comparison[0].alternateSolution.map((text, index)=>{
                              var len=0;
                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                len=mydata.decomposition[0].alternateSolution.length
                              }
                              if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.pattern[0].alternateSolution.length
                              }
                              if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.abstraction[0].alternateSolution.length
                              }
                              if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.algorithm[0].alternateSolution.length
                              }
                              return(
                                <div>
                                  <h5 id="simple-modal-description" align='center'> Solution {index+len+2} </h5>
                                  <p><b>Algorithm:</b>{algoNewToText(text.algorithm)}</p>
                                  <p><b>Analysis:</b>{text.analysis}</p>
                                </div> 
                              )})}
                          </div>
                          :null}
                </GridItem>
              </GridContainer>
           :<p>You have not attempted any problem</p>}
            </GridItem>
          )
          
        }

      ]}
    />

    </div>:<GridContainer spacing={2}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rect" width={640} height={400} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rect" width={640} height={400} />    
          </Box> 
          </GridItem>
        <GridItem xs={12} sm={12} md={12}>         
          <Skeleton variant="text" />
        </GridItem>
      </GridContainer>
    );
}

